import React, { Component } from "react";
import $ from "jquery";
import "antd/dist/antd.css";
import "./antd_custom.css";
import { TimePicker } from "antd";
import RDatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import CalculateDayModal from "../Modals/CalculateDay/CalculateDay";
import EmployeeLookup from "../Modals/EmployeeLookup/EmployeeLookup";
import Header from "../Common/Header/Header";
import TopNav from "../Common/TopNav/TopNav";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import _ from "lodash";
import Select from "react-select";
import * as UserActions from "../../Actions/UserActions/UserActions";

import {
  toBase64,
  handleAPIErr,
  handleValueOptions,
  addDragAndDropFileListners,
  removeDragAndDropFileListners,
  downloadAttachments,
  isInt,
} from "../../Utils/Helpers";
import { userAvatar, _customStyles } from "../../Constants/Constants";

import * as TimecardActions from "../../Actions/TimecardActions/TimecardActions";
import { downloadFileFromPresignedUrl, isRemoteStorage, uploadFileListToS3 } from "../../Utils/S3StorageHelper";
import Delete from "../Modals/Delete/Delete";
import DeleteTimecards from "../Modals/DeleteTimeCards/DeleteTimecards";
import UnsavedChanges from "../Modals/UnsavedChanges/UnsavedChanges";
import { Prompt, withRouter } from "react-router-dom";

const uuidv1 = require("uuid/v1");

class TimeCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timecardEntry: "List",
      timecardInterval: 1,
      isLoading: true,
      dateFormat: "DD/MM/YYYY",
      standardDateFormat: "YYYY-MM-DD",
      format: "HH:mm",
      subView: "List",
      payFrequency: "Weekly",
      payEnding: "",
      dayTimeCopyIndex: 0,
      dailyTimesCopyIndex: 0,
      dayTimeIndex: false,
      dayTimeDateMoment: moment(),
      dayTimeDate: "",
      saveDayTimeError: "",
      inputReadOnly: true,
      allowEmpty: false,
      minuteStep: localStorage.getItem("UserMinutsStep")
        ? parseInt(localStorage.getItem("UserMinutsStep"))
        : 5,

      height: 0,
      width: 0,
      isMobCalOpen: false,
      isWebCalOpen: false,

      employeeDetailsList: [], // getEmployeeDetailsList
      clonesEmployeeDetailsList: [], // copy of getEmployeeDetailsList
      employeeList: [],
      clonedEmployeeList: [],
      isPrimed: false, //if true then insertTimecard API should be called otherwise updateTimecard
      tran: "",
      approverGroup: "",
      approverOptions: [],
      employeeName: "",
      employeeCode: "",
      department: "",
      position: "",
      weekEndingDate: "",

      dailyTimes: [],
      day: "",
      date: moment(),
      finishWork: moment("00:00", "HH:mm"),
      finishWorkType: "00:00",
      finishMB1: moment("00:00", "HH:mm"),
      finishMB1Type: "00:00",
      finishMB2: moment("00:00", "HH:mm"),
      finishMB2Type: "00:00",
      finishMB3: moment("00:00", "HH:mm"),
      finishMB3Type: "00:00",
      nonDeductableMB1: false,
      nonDeductableMB2: false,
      nonDeductableMB3: false,
      totalMBDedDisabled: false,
      notes: "",
      internalNotes:"",
      payAs: "Worked",
      payAsOptions: [
        { Flag: "CON", Value: "Worked" },
        { Flag: "NW", Value: "Not Worked" },
        { Flag: "SIC", Value: "Sick" },
        { Flag: "HOL", Value: "Holiday Pay" },
        { Flag: "TIL", Value: "Time in Lieu" },
        { Flag: "PUB", Value: "Public Holiday" },
        { Flag: "PHW", Value: "Pub Hol Worked" },
      ],
      startWork: moment("00:00", "HH:mm"),
      startWorkType: "00:00",
      startMB1: moment("00:00", "HH:mm"),
      startMB1Type: "00:00",
      startMB2: moment("00:00", "HH:mm"),
      startMB2Type: "00:00",
      startMB3: moment("00:00", "HH:mm"),
      startMB3Type: "00:00",
      totalHours: "0.00",
      dayTimeTotalHours: "0.00",
      totalMB: moment("00:00", "HH:mm"),
      totalMBType: "00:00",
      travelTo: moment("00:00", "HH:mm"),
      travelToType: "00:00",
      travelFrom: moment("00:00", "HH:mm"),
      travelFromType: "00:00",
      camCall: moment("00:00", "HH:mm"),
      camCallType: "00:00",
      camWrap: moment("00:00", "HH:mm"),
      camWrapType: "00:00",
      pmtFlags: "",

      attachments: [],
      attachmentSize: 0, //default 0 Bytes,  attachments should always less than 29.5 MB
      advancedList: [], //timecard advanced list
      clonedAdvancedList: [], //copy of timecard advanced list

      dailyTimeAdvancedList: [], //daily time advanced list
      clonedDailyTimeAdvancedList: [], //copy of dailyTimeAdvancedList
      guid: null,
      activePage: null,
      selectedGuid: null,
      isPrimeTimeCardCreated: false,
      newTc:false,
      openUnsavedChangesModal:true,
      selectedBatchNos: [],
      order: "",
      selectedIndex: -1,
    };
  }

  async componentDidMount() {
    await this.props.setUserSettings();
    let timecardEntry =
      this.props.user.setUserSettings.userDetails?.timecardEntry;
    let timecardInterval =
      this.props.user.setUserSettings.userDetails?.timecardInterval;
    this.setState({
      timecardEntry,
      timecardInterval,
    });
    let promises = [];

    // promises = [this.getEmployeeList()];

    let state =
      (this.props.history.location && this.props.history.location.state) || "";
    let { tran, guid, page, selectedGuid, newTc, selectedBatchNos, order } = state;
    if(newTc){
      this.setState({ newTc: true });
    }else {
      this.setState({ newTc: false });
    }

    if (guid) {
      this.setState({ guid: guid });
    }
    if (page) {
      this.setState({ activePage: page });
    }
    if (selectedGuid) {
      this.setState({ selectedGuid: selectedGuid });
    }
    if (selectedBatchNos) {
      this.setState({ selectedBatchNos: selectedBatchNos });
    }
    if (order) {
      this.setState({ order: order });
    }
    if (tran) {
      if (tran === "newTimecard") {
        //timecard first primed and then insert api should be called (this case will only called when user wants to create timecard through dashboard)
        promises = [...promises, this.primeTimecard()];
      } else {
        //timecard was inserted and now it just be updated
        promises = [...promises, this.getTimecard(selectedGuid)];
      }
      await Promise.all(promises);
    } else {
      this.props.history.push("/timecards");
    }

    this.setState(
      {
        subView: "Add",
      },
      () => {
        setTimeout(() => {
          //adding drag and drop attachments listeners
          addDragAndDropFileListners("drop-area", this.uploadAttachment);
          //end
        }, 2000);
      }
    );
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
    $(document).ready(function () {
      $(".rotate").click(function () {
        $(this).toggleClass("up");
      });

      $(".focus_employee").focusout(function () {
        setTimeout(() => {
          $(".invoice_vender_menu1").hide();
        }, 700);
      });
    });
  }


  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    //removing drag and drop attachments listeners
    removeDragAndDropFileListners("drop-area", this.uploadAttachment);
  }

  clearTimeCardStats() {
    this.setState({
      finishWork: moment("00:00", "HH:mm"),
      finishMB1: moment("00:00", "HH:mm"),
      finishMB1Type: "00:00",
      finishMB2: moment("00:00", "HH:mm"),
      finishMB3: moment("00:00", "HH:mm"),
      finishMB3Type: "00:00",
      nonDeductableMB1: false,
      nonDeductableMB2: false,
      nonDeductableMB3: false,
      totalMBDedDisabled: false,
      startWork: moment("00:00", "HH:mm"),
      startMB1: moment("00:00", "HH:mm"),
      startMB2: moment("00:00", "HH:mm"),
      startMB2Type: "00:00",
      startMB3: moment("00:00", "HH:mm"),
      totalHours: "0.00",
      totalMB: moment("00:00", "HH:mm"),
      travelTo: moment("00:00", "HH:mm"),
      travelFrom: moment("00:00", "HH:mm"),
      camCall: moment("00:00", "HH:mm"),
      camWrap: moment("00:00", "HH:mm"),
      pmtFlags: "",
    });
  }

  /**
   * ***Note: this a Legacy method that was used to update the timecard values***
   * @param {'startWork'|'finishWork'|'totalMB'} timeFieldKey denotes which type of value to be updated, updating other values lead to unexepcted issues
   */
  handleSaveDayTimeInline = async (timeFieldKey) => {
    let {
      dailyTimes,
      startWork,
      payAs,
      day,
      travelFrom,
      totalMB,
      startMB1,
      finishMB1,
      startMB2,
      finishMB2,
      startMB3,
      finishMB3,
      nonDeductableMB2,
      nonDeductableMB1,
      nonDeductableMB3,
      finishWork,
      travelTo,
      dayTimeTotalHours,
      notes,
      internalNotes,
      dayTimeIndex,
    } = this.state;

    let index = dayTimeIndex;

    let dayTimeObj = {
      ...dailyTimes[index],
      day: day,
      finishMB1: finishMB1.format("HH:mm"),
      finishMB2: finishMB2.format("HH:mm"),
      finishMB3: finishMB3.format("HH:mm"),
      nonDeductableMB1: nonDeductableMB1 ? "1" : "0",
      nonDeductableMB2: nonDeductableMB2 ? "1" : "0",
      nonDeductableMB3: nonDeductableMB3 ? "1" : "0",
      notes: notes,
      payAs: payAs,
      internalNotes:internalNotes,
      startMB1: startMB1.format("HH:mm"),
      startMB2: startMB2.format("HH:mm"),
      startMB3: startMB3.format("HH:mm"),
      totalHours: dayTimeTotalHours,
    };

    switch (timeFieldKey) {
      case 'startWork':
        dayTimeObj.startWork = startWork.format("HH:mm");
        break;
      case 'totalMB':
        dayTimeObj.totalMB = totalMB.format("HH:mm");
        break;
      case 'finishWork':
        dayTimeObj.finishWork = finishWork.format("HH:mm");
        break;
      default:
        break;
    }

    dailyTimes[index] = dayTimeObj;

    this.updateTotalHours();
  };

  updateTotalHours = () => {
    let { dailyTimes } = this.state;

    dailyTimes = _.cloneDeep(dailyTimes);
    let totalTime = moment.duration("00:00", "HH:mm");

    dailyTimes.map((time, i) => {
      totalTime.add(moment.duration(time.totalHours, "HH:mm"));
    });

    let hours = parseInt(totalTime.asHours(), 10);
    let minutes = parseInt(totalTime.asMinutes(), 10) % 60;

    let totalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    this.setState({ totalHours: totalHours });
  };

  handleSaveDayTime = (index, subView, saveRowValues = false) => {
    let {
      startWork,
      payAs,
      day,
      date,
      travelFrom,
      totalMB,
      startMB1,
      finishMB1,
      startMB2,
      finishMB2,
      startMB3,
      finishMB3,
      nonDeductableMB2,
      nonDeductableMB1,
      nonDeductableMB3,
      finishWork,
      travelTo,
      notes,
      internalNotes,
      dailyTimes,
      camCall,
      camWrap,
      dayTimeTotalHours,
      dailyTimeAdvancedList
    } = this.state;
    let customValidation = true;

    $(".custom-time-field")
      .filter("[required]:visible")
      .each(function (i, requiredField) {
        if ($(requiredField).attr("type") === "checkbox") {
          if ($(requiredField).is(":checked")) {
            $(requiredField).parent().parent().removeClass("field_required");
          } else {
            customValidation = false;
            $(requiredField).parent().parent().addClass("field_required");
          }
        } else {
          if ($(requiredField).val() === "") {
            customValidation = false;
            $(requiredField).parent().parent().addClass("field_required");
          } else {
            $(requiredField).parent().parent().removeClass("field_required");
          }
        }
      });
    
    const dailyAdvancedList = saveRowValues ? dailyTimeAdvancedList : [...dailyTimes[index].advancedList];
    const startWorkValue = saveRowValues ? startWork.format("HH:mm") : dailyTimes[index].startWork;
    const totalMBValue = saveRowValues ? totalMB.format("HH:mm") : dailyTimes[index].totalMB;
    const finishWorkValue = saveRowValues ? finishWork.format("HH:mm") : dailyTimes[index].finishWork;
    const travelFromValue = saveRowValues ? travelFrom.format("HH:mm") : dailyTimes[index].travelFrom;
    const travelToValue = saveRowValues ? travelTo.format("HH:mm") : dailyTimes[index].travelTo;
    const camCallValue = saveRowValues ? camCall.format("HH:mm") : dailyTimes[index].camCall;
    const camWrapValue = saveRowValues ? camWrap.format("HH:mm") : dailyTimes[index].camWrap;
    const notesValue = saveRowValues  ? notes : dailyTimes[index].notes;
    const internalNotesValue = saveRowValues  ? internalNotes : dailyTimes[index].internalNotes;

    
    this.setState({ saveDayTimeError: "" });
    if (payAs !== "0" || customValidation === true) {
      let dayTimeObj = {
        ...dailyTimes[index],
        advancedList: dailyAdvancedList,
        payAs: payAs,
        date,
        day,
        travelTo: travelToValue,
        startWork: startWorkValue,
        startMB1: startMB1.format("HH:mm"),
        finishMB1: finishMB1.format("HH:mm"),
        nonDeductableMB1: nonDeductableMB1 ? "1" : "0",
        startMB2: startMB2.format("HH:mm"),
        finishMB2: finishMB2.format("HH:mm"),
        nonDeductableMB2: nonDeductableMB2 ? "1" : "0",
        startMB3: startMB3.format("HH:mm"),
        finishMB3: finishMB3.format("HH:mm"),
        nonDeductableMB3: nonDeductableMB3 ? "1" : "0",
        totalMB: totalMBValue,
        finishWork: finishWorkValue,
        travelFrom: travelFromValue,
        totalHours: dayTimeTotalHours,
        notes: notesValue,
        internalNotes: internalNotesValue,
        camCall: camCallValue,
        camWrap: camWrapValue
      };
      dailyTimes[index] = dayTimeObj;
      

      this.setState({ dailyTimes: dailyTimes }, () => {
        this.updateTotalHours();
      });
      if (subView === "Add") {
        $("#WeekTimesModalCenterClose").click();
      } else {
        this.setState({ subView: subView });
      }
    } else {
      if (payAs === "0") {
        this.setState({ saveDayTimeError: "payAs is required." });
      }
    }
  };

  handleDayTimeDate = (value, dateString) => {
    let d = new Date(dateString);
    let weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    this.setState({
      dayTimeDateMoment: value,
      dayTimeDate: value.format(this.state.standardDateFormat),
      day: weekday[d.getDay()],
    });
  };

  handleChangeDayFromTravel = (time, timeString, i, modal) => {
    let {
      totalMBDedDisabled,
      format,
    } = this.state;

    const travelTo = this.getUpdatedTime("travelTo", i);
    const startWork = this.getUpdatedTime("startWork", i);
    const finishWork = this.getUpdatedTime("finishWork", i);
    const totalMB = this.getUpdatedTime("totalMB", i);
    const startMB1 = this.getUpdatedTime("startMB1", i);
    const finishMB1 = this.getUpdatedTime("finishMB1", i);
    const startMB2 = this.getUpdatedTime("startMB2", i);
    const finishMB2 = this.getUpdatedTime("finishMB2", i);
    const startMB3 = this.getUpdatedTime("startMB3", i);
    const finishMB3 = this.getUpdatedTime("finishMB3", i);
    const nonDeductableMB1 = this.getUpdatedTime("nonDeductableMB1", i);
    const nonDeductableMB2 = this.getUpdatedTime("nonDeductableMB2", i);
    const nonDeductableMB3 = this.getUpdatedTime("nonDeductableMB3", i);

    let travel1Duration = moment.duration(timeString, "HH:mm");
    let travel2Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");

    if (startTime.isAfter(endTime)) {
      endTime.add(24, "hours");
    }

    console.log('Travel from?')

    if (totalMBDedDisabled) {
      if (!nonDeductableMB1) {
        let startTimeMB1 = moment(startMB1, "HH:mm");
        let endTimeMB1 = moment(finishMB1, "HH:mm");
        if (startTimeMB1 > endTimeMB1) {
          endTimeMB1.add(24, "hours");
        }
        let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
        endTime.subtract(durationMB1);
      }

      if (!nonDeductableMB2) {
        let startTimeMB2 = moment(startMB2, "HH:mm");
        let endTimeMB2 = moment(finishMB2, "HH:mm");
        if (startTimeMB2 > endTimeMB2) {
          endTimeMB2.add(24, "hours");
        }
        let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
        endTime.subtract(durationMB2);
      }

      if (!nonDeductableMB3) {
        let startTimeMB3 = moment(startMB3, "HH:mm");
        let endTimeMB3 = moment(finishMB3, "HH:mm");
        if (startTimeMB3 > endTimeMB3) {
          endTimeMB3.add(24, "hours");
        }
        let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
        endTime.subtract(durationMB3);
      }
    } else {
      let TotalMBDedDuration = moment.duration(
        totalMB.format("HH:mm"),
        "HH:mm"
      );
      endTime.subtract(TotalMBDedDuration);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let clonesDailyTime = this.state.dailyTimes;
    if (modal) {
      this.setState({
        travelFrom: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
      });
    } else {
      let newItem = {
        ...clonesDailyTime[i],
        advancedList: [...clonesDailyTime[i].advancedList],
        travelFrom: moment(timeString, format),
        totalHours: dayTimeTotalHours,
      };
      let result = this.updateDailyTimesItem(i, newItem)
      this.setState(
        {
          dailyTimes: result,
          travelFrom: moment(timeString, format),
          dayTimeTotalHours: dayTimeTotalHours,
          day: result[i].day,
          date: result[i].date,
        },
        () => {
          this.handleSaveDayTime(i, "Add");
        }
      );
    }
  };

  getUpdatedTime(value, i) {
    const { dailyTimes, selectedIndex } = this.state;
    const index = isInt(i) ? i : selectedIndex;
    const selected = dailyTimes[index];
    const stateValue = this.state[value];
    const selectedValue = selected[value];
    const momentStateValue = moment(stateValue, "HH:mm");
    const momentSelectedValue = moment(selectedValue, "HH:mm");
    return momentStateValue.format("HH:mm") === "00:00" ? momentSelectedValue : momentStateValue;
  }

  handleChangeDayToTravel = (time, timeString, i, modal) => {
    let {
      totalMBDedDisabled,
      format,
    } = this.state;

    const travelFrom = this.getUpdatedTime("travelFrom", i);
    const startWork = this.getUpdatedTime("startWork", i);
    const finishWork = this.getUpdatedTime("finishWork", i);
    const totalMB = this.getUpdatedTime("totalMB", i);
    const startMB1 = this.getUpdatedTime("startMB1", i);
    const finishMB1 = this.getUpdatedTime("finishMB1", i);
    const startMB2 = this.getUpdatedTime("startMB2", i);
    const finishMB2 = this.getUpdatedTime("finishMB2", i);
    const startMB3 = this.getUpdatedTime("startMB3", i);
    const finishMB3 = this.getUpdatedTime("finishMB3", i);
    const nonDeductableMB1 = this.getUpdatedTime("nonDeductableMB1", i);
    const nonDeductableMB2 = this.getUpdatedTime("nonDeductableMB2", i);
    const nonDeductableMB3 = this.getUpdatedTime("nonDeductableMB3", i);

    let travel1Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(timeString, "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime.isAfter(endTime)) {
      endTime.add(24, "hours");
    }
    console.log('Travel to?');

    if (totalMBDedDisabled) {
      if (!nonDeductableMB1) {
        let startTimeMB1 = moment(startMB1, "HH:mm");
        let endTimeMB1 = moment(finishMB1, "HH:mm");
        if (startTimeMB1 > endTimeMB1) {
          endTimeMB1.add(24, "hours");
        }
        let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
        endTime.subtract(durationMB1);
      }

      if (!nonDeductableMB2) {
        let startTimeMB2 = moment(startMB2, "HH:mm");
        let endTimeMB2 = moment(finishMB2, "HH:mm");
        if (startTimeMB2 > endTimeMB2) {
          endTimeMB2.add(24, "hours");
        }
        let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
        endTime.subtract(durationMB2);
      }

      if (!nonDeductableMB3) {
        let startTimeMB3 = moment(startMB3, "HH:mm");
        let endTimeMB3 = moment(finishMB3, "HH:mm");
        if (startTimeMB3 > endTimeMB3) {
          endTimeMB3.add(24, "hours");
        }
        let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
        endTime.subtract(durationMB3);
      }
    } else {
      let TotalMBDedDuration = moment.duration(
        totalMB.format("HH:mm"),
        "HH:mm"
      );
      endTime.subtract(TotalMBDedDuration);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let clonesDailyTime = this.state.dailyTimes;

    if (modal) {
      this.setState({
        travelTo: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
      });
    } else {
      let item = {
        ...clonesDailyTime[i],
        advancedList: [...clonesDailyTime[i].advancedList],
        travelTo: moment(timeString, format),
        totalHours: dayTimeTotalHours,
      };
      let result = this.updateDailyTimesItem(i, item)
      this.setState(
        {
          dailyTimes: result,
          travelTo: moment(timeString, format),
          dayTimeTotalHours: dayTimeTotalHours,
          day: result[i].day,
          date: result[i].date,
        },
        () => {
          this.handleSaveDayTime(i, "Add");
        }
      );
    }
  };

  handleChangeDayTimeStartInline = (time, timeString, index) => {
    let {
      format,
      payAs,
      dailyTimes,
    } = this.state;

    if (payAs === "0" && payAs[0]) {
      payAs = payAs[0].Value;
    }
    const travelFrom = moment(dailyTimes[index]?.travelFrom, 'HH:mm');
    const travelTo = moment(dailyTimes[index]?.travelTo, 'HH:mm');
    const startMB1 = moment(dailyTimes[index]?.startMB1, 'HH:mm');
    const startMB2 = moment(dailyTimes[index]?.startMB2, 'HH:mm');
    const startMB3 = moment(dailyTimes[index]?.startMB3, 'HH:mm');
    const finishMB1 = moment(dailyTimes[index]?.finishMB1, 'HH:mm');
    const finishMB2 = moment(dailyTimes[index]?.finishMB2, 'HH:mm');
    const finishMB3 = moment(dailyTimes[index]?.finishMB3, 'HH:mm');
    const totalMB = moment(dailyTimes[index]?.totalMB, 'HH:mm');
    const nonDeductableMB1 = dailyTimes[index]?.nonDeductableMB1;
    const nonDeductableMB2 = dailyTimes[index]?.nonDeductableMB2;
    const nonDeductableMB3 = dailyTimes[index]?.nonDeductableMB3;
    const totalMBDedDisabled = dailyTimes[index]?.totalMBDedDisabled;

    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    const finishWork = dailyTimes[index]?.finishWork || "00:00";
    let startTime = moment(timeString, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");

    if (startTime > endTime) {
      endTime.add(24, "hours");
    }

    if (totalMBDedDisabled) {
      if (!nonDeductableMB1) {
        let startTimeMB1 = moment(startMB1, "HH:mm");
        let endTimeMB1 = moment(finishMB1, "HH:mm");
        if (startTimeMB1 > endTimeMB1) {
          endTimeMB1.add(24, "hours");
        }
        let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
        endTime.subtract(durationMB1);
      }

      if (!nonDeductableMB2) {
        let startTimeMB2 = moment(startMB2, "HH:mm");
        let endTimeMB2 = moment(finishMB2, "HH:mm");
        if (startTimeMB2 > endTimeMB2) {
          endTimeMB2.add(24, "hours");
        }
        let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
        endTime.subtract(durationMB2);
      }

      if (!nonDeductableMB3) {
        let startTimeMB3 = moment(startMB3, "HH:mm");
        let endTimeMB3 = moment(finishMB3, "HH:mm");
        if (startTimeMB3 > endTimeMB3) {
          endTimeMB3.add(24, "hours");
        }
        let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
        endTime.subtract(durationMB3);
      }
    } else {
      let TotalMBDedDuration = moment.duration(
        totalMB.format("HH:mm"),
        "HH:mm"
      );
      endTime.subtract(TotalMBDedDuration);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);
    let day = moment(dailyTimes[index].date, 'YYYY-MM-DD').format("dddd");


    this.setState(
      {
        startWork: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        dayTimeIndex: index,
        day: day,
      },
      () => {
        this.handleSaveDayTimeInline('startWork');
      }
    );
  };

  handleChangeCamCallTime = (m, t, i) => {
    let cloneDailyTimes = this.state.dailyTimes;
    let item;
    if (i !== undefined) {
      item = {
        ...cloneDailyTimes[i],
        advancedList: [...cloneDailyTimes[i].advancedList],
        camCall: t,
      };
    }
    this.updateDailyTimesItem(i, item)
    this.setState({ 
      dailyTimes: this.updateDailyTimesItem(i, item), 
      camCall: m });
  };

  updateDailyTimesItem = (i, newObject) => {
    let cloneDailyTimes = [...this.state.dailyTimes];
    cloneDailyTimes[i] = newObject;
    return cloneDailyTimes;
  };
  

  handleChangeCamWrapTime = (m, t, i) => {
    let cloneDailyTimes = this.state.dailyTimes;
    let item;
    if (i !== undefined) {
      item = {
        ...cloneDailyTimes[i],
        advancedList: [...cloneDailyTimes[i].advancedList],
        camWrap: t,
      };
    }
    let result = this.updateDailyTimesItem(i, item)
    this.setState({ 
      dailyTimes: result,
      camWrap: m });
  };

  handleChangeDayTimeFinishInline = (time, timeString, index) => {
    let {
      format,
      payAs,
      dailyTimes,
    } = this.state;

    const travelFrom = moment(dailyTimes[index]?.travelFrom, 'HH:mm');
    const travelTo = moment(dailyTimes[index]?.travelTo, 'HH:mm');
    const startMB1 = moment(dailyTimes[index]?.startMB1, 'HH:mm');
    const startMB2 = moment(dailyTimes[index]?.startMB2, 'HH:mm');
    const startMB3 = moment(dailyTimes[index]?.startMB3, 'HH:mm');
    const finishMB1 = moment(dailyTimes[index]?.finishMB1, 'HH:mm');
    const finishMB2 = moment(dailyTimes[index]?.finishMB2, 'HH:mm');
    const finishMB3 = moment(dailyTimes[index]?.finishMB3, 'HH:mm');
    const totalMB = moment(dailyTimes[index]?.totalMB, 'HH:mm');
    const nonDeductableMB1 = dailyTimes[index]?.nonDeductableMB1;
    const nonDeductableMB2 = dailyTimes[index]?.nonDeductableMB2;
    const nonDeductableMB3 = dailyTimes[index]?.nonDeductableMB3;
    const totalMBDedDisabled = dailyTimes[index]?.totalMBDedDisabled;

    if (payAs === "0" && payAs[0]) {
      payAs = payAs[0].Value;
    }
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    // Take the finish hour from current day from dailyTimes instead of state.
    // As for some reason the state had previous index
    const startWork = dailyTimes[index]?.startWork || "00:00";
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(timeString, "HH:mm");

    if (startTime > endTime) {
      endTime.add(24, "hours");
    }

    if (totalMBDedDisabled) {
      if (!nonDeductableMB1) {
        let startTimeMB1 = moment(startMB1, "HH:mm");
        let endTimeMB1 = moment(finishMB1, "HH:mm");
        if (startTimeMB1 > endTimeMB1) {
          endTimeMB1.add(24, "hours");
        }
        let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
        endTime.subtract(durationMB1);
      }

      if (!nonDeductableMB2) {
        let startTimeMB2 = moment(startMB2, "HH:mm");
        let endTimeMB2 = moment(finishMB2, "HH:mm");
        if (startTimeMB2 > endTimeMB2) {
          endTimeMB2.add(24, "hours");
        }
        let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
        endTime.subtract(durationMB2);
      }

      if (!nonDeductableMB3) {
        let startTimeMB3 = moment(startMB3, "HH:mm");
        let endTimeMB3 = moment(finishMB3, "HH:mm");
        if (startTimeMB3 > endTimeMB3) {
          endTimeMB3.add(24, "hours");
        }
        let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
        endTime.subtract(durationMB3);
      }
    } else {
      let TotalMBDedDuration = moment.duration(
        totalMB.format("HH:mm"),
        "HH:mm"
      );
      endTime.subtract(TotalMBDedDuration);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);
    
    let day = moment(dailyTimes[index]?.date, 'YYYY-MM-DD').format("dddd");

    this.setState(
      {
        finishWork: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        dayTimeIndex: index,
        day: day,
      },
      () => {
        this.handleSaveDayTimeInline('finishWork');
      }
    );
  };

  handleChangeDayTimeTotalMBDedInline = (time, timeString, index) => {
    let { format, payAs, dailyTimes } =
      this.state;

    const travelFrom = moment(dailyTimes[index]?.travelFrom, 'HH:mm');
    const travelTo = moment(dailyTimes[index]?.travelTo, 'HH:mm');

    if (payAs === "0" && payAs[0]) {
      payAs = payAs[0].Value;
    }
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    const startWork = dailyTimes[index]?.startWork || "00:00";
    const finishWork = dailyTimes[index]?.finishWork || "00:00";
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    let TotalMBDedDuration = moment.duration(timeString, "HH:mm");
    endTime.subtract(TotalMBDedDuration);

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);

    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let day = moment(dailyTimes[index].date, 'YYYY-MM-DD').format("dddd");

    this.setState(
      {
        totalMB: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        dayTimeIndex: index,
        day: day,
      },
      () => {
        this.handleSaveDayTimeInline('totalMB');
      }
    );
  };

  handleChangeDayTimeStart = (time, timeString) => {
    let {
      travelFrom,
      finishWork,
      totalMBDedDisabled,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
      payAs,
    } = this.state;

    if (payAs === "0" && payAs[0]) {
      payAs = payAs[0].Value;
    }
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(timeString, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");

    if (startTime > endTime) {
      endTime.add(24, "hours");
    }

    if (totalMBDedDisabled) {
      if (!nonDeductableMB1) {
        let startTimeMB1 = moment(startMB1, "HH:mm");
        let endTimeMB1 = moment(finishMB1, "HH:mm");
        if (startTimeMB1 > endTimeMB1) {
          endTimeMB1.add(24, "hours");
        }
        let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
        endTime.subtract(durationMB1);
      }

      if (!nonDeductableMB2) {
        let startTimeMB2 = moment(startMB2, "HH:mm");
        let endTimeMB2 = moment(finishMB2, "HH:mm");
        if (startTimeMB2 > endTimeMB2) {
          endTimeMB2.add(24, "hours");
        }
        let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
        endTime.subtract(durationMB2);
      }

      if (!nonDeductableMB3) {
        let startTimeMB3 = moment(startMB3, "HH:mm");
        let endTimeMB3 = moment(finishMB3, "HH:mm");
        if (startTimeMB3 > endTimeMB3) {
          endTimeMB3.add(24, "hours");
        }
        let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
        endTime.subtract(durationMB3);
      }
    } else {
      let TotalMBDedDuration = moment.duration(
        totalMB.format("HH:mm"),
        "HH:mm"
      );
      endTime.subtract(TotalMBDedDuration);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    this.setState({
      startWork: moment(timeString, format),
      dayTimeTotalHours: dayTimeTotalHours,
    });
  };

  handleChangeDayTimeFinish = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      totalMBDedDisabled,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
      payAs,
    } = this.state;

    if (payAs === "0" && payAs[0]) {
      payAs = payAs[0].Value;
    }
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(timeString, "HH:mm");

    if (startTime > endTime) {
      endTime.add(24, "hours");
    }

    if (totalMBDedDisabled) {
      if (!nonDeductableMB1) {
        let startTimeMB1 = moment(startMB1, "HH:mm");
        let endTimeMB1 = moment(finishMB1, "HH:mm");
        if (startTimeMB1 > endTimeMB1) {
          endTimeMB1.add(24, "hours");
        }
        let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
        endTime.subtract(durationMB1);
      }

      if (!nonDeductableMB2) {
        let startTimeMB2 = moment(startMB2, "HH:mm");
        let endTimeMB2 = moment(finishMB2, "HH:mm");
        if (startTimeMB2 > endTimeMB2) {
          endTimeMB2.add(24, "hours");
        }
        let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
        endTime.subtract(durationMB2);
      }

      if (!nonDeductableMB3) {
        let startTimeMB3 = moment(startMB3, "HH:mm");
        let endTimeMB3 = moment(finishMB3, "HH:mm");
        if (startTimeMB3 > endTimeMB3) {
          endTimeMB3.add(24, "hours");
        }
        let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
        endTime.subtract(durationMB3);
      }
    } else {
      let TotalMBDedDuration = moment.duration(
        totalMB.format("HH:mm"),
        "HH:mm"
      );
      endTime.subtract(TotalMBDedDuration);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    this.setState({
      finishWork: moment(timeString, format),
      dayTimeTotalHours: dayTimeTotalHours,
    });
  };

  getEmployeeDetailsList = async () => {
    let { employeeDetailsList, employeeCode } = this.state;
    this.setState({
      isLoading: true,
    });
    await this.props.getEmployeeDetailsList(employeeCode);

    if (this.props.timecard.getEmployeeDetailsListSuccess) {
      employeeDetailsList = this.props.timecard.getEmployeeDetailsList;
    }

    if (this.props.timecard.getEmployeeDetailsListError) {
      handleAPIErr(this.props.timecard.getEmployeeDetailsListError, this.props);
    }
    this.setState({
      isLoading: false,
      employeeDetailsList: employeeDetailsList,
      clonesEmployeeDetailsList: employeeDetailsList,
    });
    this.props.clearTimecardStates();
  };

  handleChangeDayTimeStartMeal = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      nonDeductableMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
    } = this.state;

    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(time, "HH:mm");
    let endTimeMB1 = moment(finishMB1, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    totalMB.add(durationMB1);

    let startTimeMB2 = moment(startMB2, "HH:mm");
    let endTimeMB2 = moment(finishMB2, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    totalMB.add(durationMB2);

    let startTimeMB3 = moment(startMB3, "HH:mm");
    let endTimeMB3 = moment(finishMB3, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    totalMB.add(durationMB3);

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState(
      {
        startMB1: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        totalMB: moment(totalMB, format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  handleChangeDayTimeFinishMeal1 = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      nonDeductableMB1,
      startMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
    } = this.state;
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(startMB1, "HH:mm");
    let endTimeMB1 = moment(time, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    totalMB.add(durationMB1);

    let startTimeMB2 = moment(startMB2, "HH:mm");
    let endTimeMB2 = moment(finishMB2, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    totalMB.add(durationMB2);

    let startTimeMB3 = moment(startMB3, "HH:mm");
    let endTimeMB3 = moment(finishMB3, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    totalMB.add(durationMB3);

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState(
      {
        finishMB1: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        totalMB: moment(totalMB, format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  handleChangeDayTimeStartMeal2 = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
    } = this.state;

    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(startMB1, "HH:mm");
    let endTimeMB1 = moment(finishMB1, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    totalMB.add(durationMB1);

    let startTimeMB2 = moment(time, "HH:mm");
    let endTimeMB2 = moment(finishMB2, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    totalMB.add(durationMB2);

    let startTimeMB3 = moment(startMB3, "HH:mm");
    let endTimeMB3 = moment(finishMB3, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    totalMB.add(durationMB3);

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState(
      {
        startMB2: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        totalMB: moment(totalMB, format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  handleChangeDayTimeFinishMeal2 = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
    } = this.state;
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(startMB1, "HH:mm");
    let endTimeMB1 = moment(finishMB1, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    totalMB.add(durationMB1);

    let startTimeMB2 = moment(startMB2, "HH:mm");
    let endTimeMB2 = moment(time, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    totalMB.add(durationMB2);

    let startTimeMB3 = moment(startMB3, "HH:mm");
    let endTimeMB3 = moment(finishMB3, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    totalMB.add(durationMB3);

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState(
      {
        finishMB2: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        totalMB: moment(totalMB, format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  handleChangeDayTimeStartMeal3 = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      totalMBDedDisabled,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
      payAs,
    } = this.state;

    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(startMB1, "HH:mm");
    let endTimeMB1 = moment(finishMB1, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    totalMB.add(durationMB1);

    let startTimeMB2 = moment(startMB2, "HH:mm");
    let endTimeMB2 = moment(finishMB2, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    totalMB.add(durationMB2);

    let startTimeMB3 = moment(time, "HH:mm");
    let endTimeMB3 = moment(finishMB3, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    totalMB.add(durationMB3);

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState(
      {
        startMB3: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        totalMB: moment(totalMB, format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  handleChangeDayTimeFinishMeal3 = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      totalMBDedDisabled,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
      payAs,
    } = this.state;
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(startMB1, "HH:mm");
    let endTimeMB1 = moment(finishMB1, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    totalMB.add(durationMB1);

    let startTimeMB2 = moment(startMB2, "HH:mm");
    let endTimeMB2 = moment(finishMB2, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    totalMB.add(durationMB2);

    let startTimeMB3 = moment(startMB3, "HH:mm");
    let endTimeMB3 = moment(time, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    totalMB.add(durationMB3);

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState(
      {
        finishMB3: moment(timeString, format),
        dayTimeTotalHours: dayTimeTotalHours,
        totalMB: moment(totalMB, format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  handleChangeDayTimeTotalMBDed = (time, timeString) => {
    let {
      travelFrom,
      startWork,
      finishWork,
      totalMBDedDisabled,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
      payAs,
    } = this.state;
    if (payAs === "0" && payAs[0]) {
      payAs = payAs[0].Value;
    }
    let travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    let TotalMBDedDuration = moment.duration(timeString, "HH:mm");
    endTime.subtract(TotalMBDedDuration);

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(travel1Duration);
    duration.add(travel2Duration);

    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    this.setState({
      totalMB: moment(timeString, format),
      dayTimeTotalHours: dayTimeTotalHours,
    });
  };

  getDateFormate = (date, formate) => {
    let datestring = date * 1000;
    if (formate === 1) {
      return (
        new Date(datestring).getFullYear() +
        "-" +
        String(new Date(datestring).getMonth() + 1).padStart(2, 0) +
        "-" +
        String(new Date(datestring).getDate()).padStart(2, 0)
      );
    }
    if (formate === 2) {
      return (
        String(new Date(datestring).getDate()).padStart(2, 0) +
        "/" +
        String(new Date(datestring).getMonth() + 1).padStart(2, 0) +
        "/" +
        new Date(datestring).getFullYear()
      );
    }
    return date;
  };

  updateMealBreakTime = () => {
    let {
      travelFrom,
      startWork,
      finishWork,
      nonDeductableMB1,
      startMB1,
      finishMB1,
      nonDeductableMB2,
      startMB2,
      finishMB2,
      nonDeductableMB3,
      startMB3,
      finishMB3,
      totalMB,
      format,
      travelTo,
    } = this.state;

    let Travel1Duration = moment.duration(travelTo.format("HH:mm"), "HH:mm");
    let Travel2Duration = moment.duration(travelFrom.format("HH:mm"), "HH:mm");
    let startTime = moment(startWork, "HH:mm");
    let endTime = moment(finishWork, "HH:mm");
    if (startTime > endTime) {
      endTime.add(24, "hours");
    }
    totalMB = moment.duration("00:00", "HH:mm");

    let startTimeMB1 = moment(startMB1, "HH:mm");
    let endTimeMB1 = moment(finishMB1, "HH:mm");
    if (startTimeMB1 > endTimeMB1) {
      endTimeMB1.add(24, "hours");
    }
    let durationMB1 = moment.duration(endTimeMB1.diff(startTimeMB1));
    if (!nonDeductableMB1) {
      totalMB.add(durationMB1);
    }

    let startTimeMB2 = moment(startMB2, "HH:mm");
    let endTimeMB2 = moment(finishMB2, "HH:mm");
    if (startTimeMB2 > endTimeMB2) {
      endTimeMB2.add(24, "hours");
    }
    let durationMB2 = moment.duration(endTimeMB2.diff(startTimeMB2));
    if (!nonDeductableMB2) {
      totalMB.add(durationMB2);
    }

    let startTimeMB3 = moment(startMB3, "HH:mm");
    let endTimeMB3 = moment(finishMB3, "HH:mm");
    if (startTimeMB3 > endTimeMB3) {
      endTimeMB3.add(24, "hours");
    }
    let durationMB3 = moment.duration(endTimeMB3.diff(startTimeMB3));
    if (!nonDeductableMB3) {
      totalMB.add(durationMB3);
    }

    if (!nonDeductableMB1) {
      endTime.subtract(durationMB1);
    }

    if (!nonDeductableMB2) {
      endTime.subtract(durationMB2);
    }

    if (!nonDeductableMB3) {
      endTime.subtract(durationMB3);
    }

    let duration = moment.duration(endTime.diff(startTime));
    duration.add(Travel1Duration);
    duration.add(Travel2Duration);
    let hours = parseInt(duration.asHours(), 10);
    let minutes = parseInt(duration.asMinutes(), 10) % 60;
    // let totalHours =
    //   String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let dayTimeTotalHours =
      String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);

    let hoursmbded = parseInt(totalMB.asHours(), 10);
    let minutesmbded = parseInt(totalMB.asMinutes(), 10) % 60;
    totalMB =
      String(hoursmbded).padStart(2, 0) +
      ":" +
      String(minutesmbded).padStart(2, 0);

    this.setState({
      dayTimeTotalHours: dayTimeTotalHours,
      totalMB: moment(totalMB, format),
    });
  };

  handleChangeDayTime = (event) => {
    this.setState({ saveDayTimeError: "" });
    const name = event.target.name;
    const value = event.target.value;
    //alert(name);
    if (
      name === "nonDeductableMB1" ||
      name === "nonDeductableMB2" ||
      name === "nonDeductableMB3"
    ) {
      this.setState({ [name]: event.target.checked }, () => {
        this.updateMealBreakTime();
      });
    } else {
      this.setState({ [name]: value !== "" ? value : null });
    }
  };

  //when click on td then it setstate the current object values in the state
  handleDayTimeInline = (index, subView) => {
    let { format, dayTimeIndex, dailyTimes, dateFormat, standardDateFormat } =
      this.state;
    if (index !== dayTimeIndex) {
      let day = dailyTimes[index];
      this.setState(
        {
          saveDayTimeError: "",
          subView,
          dayTimeIndex: index,
          dayTimeCopyIndex: index,
          dayTimeDateMoment: day.date
            ? moment(this.dailyTimesDateFormat(day.date), dateFormat)
            : "",
          dayTimeDate: day.date
            ? moment(this.dailyTimesDateFormat(day.date), dateFormat).format(
                standardDateFormat
              )
            : "",
          day: day.day,
          date: day.date,
          finishWork: day.finishWork
            ? moment(day.finishWork, format)
            : moment("00:00", format),
          finishMB1: day.finishMB1
            ? moment(day.finishMB1, format)
            : moment("00:00", format),
          finishMB2: day.finishMB2
            ? moment(day.finishMB2, format)
            : moment("00:00", format),
          finishMB3: day.finishMB3
            ? moment(day.finishMB3, format)
            : moment("00:00", format),
          nonDeductableMB1: day.nonDeductableMB1 === "0" || day.nonDeductableMB1 === "" ? false : true,
          nonDeductableMB2: day.nonDeductableMB2 === "0" || day.nonDeductableMB2 === "" ? false : true,
          nonDeductableMB3: day.nonDeductableMB3 === "0" || day.nonDeductableMB3 === "" ? false : true,
          notes: day.notes ? day.notes : null,
          internalNotes: day.internalNotes ? day.internalNotes : null,
          payAs: day.payAs ? day.payAs : "0",
          startWork: day.startWork
            ? moment(day.startWork, format)
            : moment("00:00", format),
          startMB1: day.startMB1
            ? moment(day.startMB1, format)
            : moment("00:00", format),
          startMB2: day.startMB2
            ? moment(day.startMB2, format)
            : moment("00:00", format),
          startMB3: day.startMB3
            ? moment(day.startMB3, format)
            : moment("00:00", format),
          // totalHours: day.totalHours ? day.totalHours : "00:00",
          dayTimeTotalHours: day.totalHours ? day.totalHours : "00:00",
          totalMB: day.totalMB
            ? moment(day.totalMB, format)
            : moment("00:00", format),
          travelTo: day.travelTo
            ? moment(day.travelTo, format)
            : moment("00:00", format),
          travelFrom: day.travelFrom
            ? moment(day.travelFrom, format)
            : moment("00:00", format),
          camCall: day.camCall
            ? moment(day.camCall, format)
            : moment("00:00", format),
          camWrap: day.camWrap
            ? moment(day.camWrap, format)
            : moment("00:00", format),
        },
        () => {
          this.updateTotalMBDedDisabledState();
        }
      );
    }
  };

  handleCopyYesterdaysTimes = (index) => {
    let { format, dailyTimes } = this.state;
    if (index === 0) {
      index = dailyTimes.length - 1;
    } else {
      index = index - 1;
    }
    let day = dailyTimes[index];
    this.setState(
      {
        dayTimeCopyIndex: index,
        finishWorkType: day.finishWork ? day.finishWork : "00:00",
        finishWork: day.finishWork
          ? moment(day.finishWork, format)
          : moment("00:00", format),
        finishMB1Type: day.finishMB1 ? day.finishMB1 : "00:00",
        finishMB1: day.finishMB1
          ? moment(day.finishMB1, format)
          : moment("00:00", format),
        finishMB2Type: day.finishMB2 ? day.finishMB2 : "00:00",
        finishMB2: day.finishMB2
          ? moment(day.finishMB2, format)
          : moment("00:00", format),
        finishMB3Type: day.finishMB3 ? day.finishMB3 : "00:00",
        finishMB3: day.finishMB3
          ? moment(day.finishMB3, format)
          : moment("00:00", format),
        nonDeductableMB1: day.nonDeductableMB1 === "0" ? false : true,
        nonDeductableMB2: day.nonDeductableMB2 === "0" ? false : true,
        nonDeductableMB3: day.nonDeductableMB3 === "0" ? false : true,
        notes: day.notes ? day.notes : null,
        internalNotes: day.internalNotes ? day.internalNotes : null,
        payAs: day.payAs,
        // startMB1.format("HH:mm")
        startWorkType: day.startWork ? day.startWork : "00:00",
        startWork: day.startWork
          ? moment(day.startWork, format)
          : moment("00:00", format),
        startMB1Type: day.startMB1 ? day.startMB1 : "00:00",
        startMB1: day.startMB1
          ? moment(day.startMB1, format)
          : moment("00:00", format),
        startMB2Type: day.startMB2 ? day.startMB2 : "00:00",
        startMB2: day.startMB2
          ? moment(day.startMB2, format)
          : moment("00:00", format),
        startMB3Type: day.startMB3 ? day.startMB3 : "00:00",
        startMB3: day.startMB3
          ? moment(day.startMB3, format)
          : moment("00:00", format),
        // totalHours: day.totalHours ? day.totalHours : "00:00",
        dayTimeTotalHours: day.totalHours ? day.totalHours : "00:00",
        totalMBType: day.totalMB ? day.totalMB : "00:00",
        totalMB: day.totalMB
          ? moment(day.totalMB, format)
          : moment("00:00", format),
        travelToType: day.travelTo ? day.travelTo : "00:00",
        travelTo: day.travelTo
          ? moment(day.travelTo, format)
          : moment("00:00", format),
        travelFromType: day.travelFrom ? day.travelFrom : "00:00",
        travelFrom: day.travelFrom
          ? moment(day.travelFrom, format)
          : moment("00:00", format),
      },
      () => {
        this.updateTotalMBDedDisabledState();
      }
    );
  };

  renderPayasDropdown = () => {
    return this.state.payAsOptions.map((obj, i) => (
      <option key={i} value={obj.Value}>
        {obj.Value}
      </option>
    ));
  };

  handleCalendar = (element) => {
    $(element + " div input").click();
  };

  disabledDate = (current) => {
    let { payEnding } = this.state;

    if (payEnding) {
      if (current) {
        return payEnding !== current.format("dddd");
      }
    } else {
      // Can not select days before today and today
      //return current && current < moment().endOf('day');
      return false;
    }
  };

  // ########## MOBILE SECREENS ####################
  handleSubView = async (element, clear) => {
    if (element === "ListMobile") {
      let saveConfirm = window.confirm("Would you like to Save?");
      if (saveConfirm === true) {
        $("#SaveTimeCardMobile").click();
        return false;
      }
      element = "List";
      this.setState({ subView: element, isLoading: false });
    } else {
      this.setState({ subView: element, isLoading: false });
    }

    if (clear === "Yes") {
      let index = "0";

      this.setState({
        dailyTimesCopyIndex: 0,
        subView: element,
        dailyTimes: [],
        payFrequency: "Weekly",
        weekEndingDate: "",
        totalHours: "00:00",
        payEnding: "",
      });
    }
  };

  renderDayTimes = (view) => {
    let {
      dayTimeDateMoment,
      payAs,
      saveDayTimeError,
      day,
      minuteStep,
      inputReadOnly,
      allowEmpty,
      travelFrom,
      format,
      dateFormat,
      startWork,
      totalMB,
      totalMBDedDisabled,
      finishWork,
      travelTo,
      totalHours,
      notes,
      internalNotes,
      dayTimeIndex,
      isLoading,
      dayTimeCopyIndex,
      dayTimeTotalHours,
    } = this.state;

    return (
      <div className="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 time_table_mrg_res">
        <div className="res_top_timecard">
          <div className="form__inner-flex">
            <div className="col-xs-2 chev_res_let">
              <a
                className="svg__icons1"
                href="javascript:void(0)"
                onClick={() => this.handleSubView("WeekTimes")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="2398 1881 13 19.418"
                >
                  <path
                    id="ic_chevron_left_24px"
                    className="cls-1"
                    d="M21,8.282,18.526,6,8,15.709l10.526,9.709L21,23.136l-8.035-7.427Z"
                    transform="translate(2390 1875)"
                  ></path>
                </svg>
              </a>
            </div>

            <div className="col-xs-8 text-center text--wrapper--one">
              <div>Digital Timesheet</div>
            </div>
          </div>

          {/* <div className="col-xs-8 text-center">Digital Timesheet</div> */}
          <div className="clear20"></div>
        </div>
        <div className="clear5"></div>
        <div className="clear20"></div>

        <div className="col-xs-12 profile_setting_pop p0 profile_setting_pop_5">
          <div className="clear5"></div>
          <div className="clear70-wrap"></div>
          <div className="col-sm-12 p-0">
            <div className="col-sm-6 p0">
              <button
                type="button"
                className="btn_copy_time"
                onClick={() => this.handleCopyYesterdaysTimes(dayTimeCopyIndex)}
              >
                <span>Copy Yesterdays Times</span>
              </button>
            </div>
            <div className="clear20"></div>
            <div className="mb-40"></div>
            <form className="form-horizontal">
              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-xs-4 form__lbl--one form__mx-wraper"
                  htmlFor="payAs"
                >
                  Pay As
                </label>
                <div className="col-xs-8">
                  <select
                    className="form-control pro_input_pop"
                    name="payAs"
                    value={payAs}
                    onChange={this.handleChangeDayTime}
                  >
                    <option value="0">Select</option>
                    {this.renderPayasDropdown()}
                  </select>
                  <span
                    className="doc_file_error"
                    style={{ position: "initial" }}
                  >
                    {saveDayTimeError ? saveDayTimeError : ""}
                  </span>
                </div>
              </div>

              <div className="form-group form__inner-flex ">
                <label
                  className="control-label col-xs-4 form__lbl--one form__mx-wraper"
                  htmlFor="Email"
                >
                  Date
                </label>
                <div className="col-xs-6 mr__right-wrapper">
                  <RDatePicker
                    selected={dayTimeDateMoment?.toDate() || new Date()}
                    onChange={(e) => {
                      const momentInstance = moment(e);
                      this.handleDayTimeDate(momentInstance);
                    }}
                    dateFormat={dateFormat?.replace(/D/g, 'd')?.replace(/Y/g, 'y')}
                    className="calendarDayTimeDateMobile"
                    disabled
                  ></RDatePicker>
                </div>
                <div className="col-xs-1 calendar_time2">
                  <a
                    href="javascript:void(0)"
                    onClick={() =>
                      this.handleCalendar(".calendarDayTimeDateMobile")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="2936.352 349.176 18.501 23.145"
                    >
                      <path
                        id="ic_date_range_24px"
                        className="cls-1"
                        d="M9.167,12.415H7.111V14.73H9.167Zm4.111,0H11.223V14.73h2.056Zm4.111,0H15.334V14.73H17.39Zm2.056-8.1H18.418V2H16.362V4.314H8.139V2H6.084V4.314H5.056A2.188,2.188,0,0,0,3.01,6.629L3,22.83a2.2,2.2,0,0,0,2.056,2.314h14.39A2.2,2.2,0,0,0,21.5,22.83V6.629A2.2,2.2,0,0,0,19.446,4.314Zm0,18.516H5.056V10.1h14.39Z"
                        transform="translate(2933.352 347.176)"
                      />
                    </svg>
                  </a>
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Day
                </label>
                <div className="col-xs-8" style={{ paddingTop: "5px" }}>
                  {day}
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-sm-3 form__lbl--one"
                  htmlFor="Mobile"
                >
                  Cam Call
                </label>
                <div className="col-sm-8" style={{ textAlign: "left" }}>
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={moment(this.state.camCall, format)}
                    format={format}
                    onChange={(moment, time) =>
                      this.handleChangeCamCallTime(moment, time)
                    }
                    id={`d_camCall_add`}
                    onClick={() => this.fixOverflowIssue(`d_camCall_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                    // onChange={this.handleChangeDayTimeStart}
                  />
                </div>
              </div>
              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-sm-3 form__lbl--one"
                  htmlFor="Mobile"
                >
                  Cam Wrap
                </label>
                <div className="col-sm-8" style={{ textAlign: "left" }}>
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={moment(this.state.camWrap, format)}
                    format={format}
                    onChange={(moment, time) =>
                      this.handleChangeCamWrapTime(moment, time)
                    }
                    id={`d_camWrap_add`}
                    onClick={() => this.fixOverflowIssue(`d_camWrap_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>
              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-xs-4 form__lbl--one form__mx-wraper"
                  htmlFor="Mobile"
                >
                  Travel To
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={moment(this.state.travelTo, format)}
                    format={format}
                    onChange={(m, t) =>
                      this.handleChangeDayFromTravel(m, t, "", true)
                    }
                    id={`d_travelTo_add`}
                    onClick={() => this.fixOverflowIssue(`d_travelTo_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Start Work
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={startWork}
                    format={format}
                    onChange={this.handleChangeDayTimeStart}
                    id={`d_startWork_add`}
                    onClick={() => this.fixOverflowIssue(`d_startWork_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-xs-5 form__lbl--one form__mx-wraper"
                  htmlFor="Email"
                >
                  Meal Break
                </label>
                <div className="col-xs-7">
                  <div className="col-xs-12 p0 btn_time_time2_svg">
                    <TimePicker
                      showNow={false}
                      allowClear={false}
                      minuteStep={minuteStep}
                      inputReadOnly={inputReadOnly}
                      allowEmpty={allowEmpty}
                      value={totalMB}
                      format={format}
                      onChange={this.handleChangeDayTimeTotalMBDed}
                      disabled={totalMBDedDisabled}
                      id={`d_mealBreak_add`}
                      onClick={() => this.fixOverflowIssue(`d_mealBreak_add`)}
                      getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="-4690 1327 10 16.19"
                      style={{ top: "11", cursor: "pointer" }}
                      onClick={() => this.handleSubView("BreakTimes")}
                    >
                      <path
                        id="ic_chevron_right_24px"
                        className="cls-1"
                        d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                        transform="translate(-4698.59 1321)"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-xs-4 form__lbl--one form__mx-wraper"
                  htmlFor="Email"
                >
                  Finish Work:
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={finishWork}
                    format={format}
                    onChange={this.handleChangeDayTimeFinish}
                    id={`d_finishWork_add`}
                    onClick={() => this.fixOverflowIssue(`d_finishWork_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-xs-4 form__lbl--one form__mx-wraper"
                  htmlFor="Email"
                >
                  Travel From:
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={moment(this.state.travelFrom, format)}
                    format={format}
                    onChange={(m, t) =>
                      this.handleChangeDayToTravel(m, t, "", true)
                    }
                    id={`d_travelFrom_add`}
                    onClick={() => this.fixOverflowIssue(`d_travelFrom_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Total Hours
                </label>
                <div className="col-xs-8" style={{ paddingTop: "5px" }}>
                  {dayTimeTotalHours}
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-xs-4 form__lbl--one form__mx-wraper"
                  htmlFor="Email"
                >
                  Note:
                </label>
                <div className="col-xs-8">
                  <input
                    className="form-control pro_input_pop"
                    placeholder=""
                    type="text"
                    name="notes"
                    value={notes}
                    onChange={this.handleChangeDayTime}
                  />
                </div>
              </div>
              <div className="clear20"></div>
              <div
                className="col-sm-6 pull-right"
                style={{ paddingRight: "0" }}
              >
                <input
                  name=""
                  className="btn_save_pro btn_save_pro_5"
                  value="Save"
                  type="button"
                  onClick={() =>
                    this.handleSaveDayTime(dayTimeIndex, "WeekTimes")
                  }
                  disabled={isLoading}
                />
                <input
                  name=""
                  className="btn_cancel_pro nn"
                  value="Cancel"
                  type="button"
                  onClick={() => this.handleSubView("WeekTimes")}
                />

                <div className="clear40"></div>
              </div>

              <div className="clearfix"></div>
            </form>

            <div className="clear5"></div>

            <div className="clear40"></div>
            <div className="clear20"></div>
          </div>
        </div>
      </div>
    );
  };

  renderWeekTimes = (view) => {
    let {
      weekEndingDate,
      dailyTimesCopyIndex,
      dailyTimes,
      totalHours,
      isLoading,
    } = this.state;
    return (
      <div className="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 time_table_mrg_res">
        <div className="clear70-wrap"></div>
        <div className="res_top_timecard">
          <div className="form__inner-flex">
            <div className="col-xs-2 chev_res_let">
              <a
                className="svg__icons1"
                href={null}
                onClick={() => this.handleSubView("Add", "No")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="2398 1881 13 19.418"
                >
                  <path
                    id="ic_chevron_left_24px"
                    className="cls-1"
                    d="M21,8.282,18.526,6,8,15.709l10.526,9.709L21,23.136l-8.035-7.427Z"
                    transform="translate(2390 1875)"
                  ></path>
                </svg>
              </a>
            </div>
            <div className="col-xs-8 text-center text--wrapper--one">
              <div>Digital Timesheet</div>
            </div>
          </div>

          {/* <div className="col-xs-8 text-center">Digital fff Timesheet</div> */}
          <div className="clear20"></div>
        </div>
        <div className="clear5"></div>
        <div className="clear20"></div>

        <div className="col-xs-12 profile_setting_pop p0">
          <div className="clear5"></div>
          <div className="col-sm-12 p-0">
            <div className="col-sm-6 p-0 mb-40">
              <button
                type="button"
                href="#"
                className="btn_copy_time"
                onClick={this.handleCopyLastWeekTimes}
              >
                <span>Copy Last Weeks Times</span>
              </button>
            </div>
            <div className="clear20"></div>

            <table className="table table-bordered table-sm timecard2_table res_table_time_svg5">
              <thead>
                <tr>
                  <th width="20%" align="center">
                    Date
                  </th>
                  <th width="20%" align="center">
                    Day
                  </th>
                  <th width="10%" align="center">
                    Hours
                  </th>
                  <th width="10%" align="center">
                    &nbsp;
                  </th>
                </tr>
              </thead>
              <tbody>
                {weekEndingDate !== "" ? (
                  dailyTimes.length === 0 ? (
                    <tr key="empty">
                      <td align="center" colSpan="4">
                        <strong>Please select period ending date.</strong>
                      </td>
                    </tr>
                  ) : (
                    this.renderDailyTimesList(dailyTimes, view)
                  )
                ) : (
                  <tr key="empty">
                    <td align="center" colSpan="4">
                      <strong>Please select period ending date.</strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="clear5"></div>
            <div className="row">
              <div className="col-sm-12 p0">
                <div className="pull-right ">
                  <div className="pull-right label_timecard2">
                    <span style={{ paddingLeft: "20px" }}>
                      {weekEndingDate !== "" ? totalHours : "00:00"}
                    </span>
                  </div>
                </div>
                <div className="pull-right label_timecard2">
                  Total(Hrs):&nbsp;
                </div>
              </div>
            </div>

            <div className="flex__wrapper--four">
              <input
                name=""
                className="btn_save_pro btn_save_pro_5"
                value="Save"
                type="button"
                onClick={() => this.handleSubView("Add", "No")}
                disabled={isLoading}
              />
              <input
                name=""
                className="btn_cancel_pro nn"
                value="Cancel"
                type="button"
                onClick={() => this.handleSubView("Add", "No")}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderBreakTimes = (view) => {
    let {
      minuteStep,
      inputReadOnly,
      allowEmpty,
      format,
      dayTimeIndex,
      isLoading,
      startMB1,
      finishMB1,
      startMB2,
      finishMB2,
      startMB3,
      finishMB3,
      nonDeductableMB1,
      nonDeductableMB2,
      nonDeductableMB3,
    } = this.state;
    return (
      <div className="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 time_table_mrg_res">
        <div className="res_top_timecard">
          <div className="form__inner-flex">
            <div className="col-xs-2 chev_res_let">
              <a
                className="svg__icons1"
                href="javascript:void(0)"
                onClick={() => this.handleSubView("DayTimes")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="2398 1881 13 19.418"
                >
                  <path
                    id="ic_chevron_left_24px"
                    className="cls-1"
                    d="M21,8.282,18.526,6,8,15.709l10.526,9.709L21,23.136l-8.035-7.427Z"
                    transform="translate(2390 1875)"
                  ></path>
                </svg>
              </a>
            </div>

            <div className="col-xs-8 text-center text--wrapper--one">
              <div>Meal Break Times</div>
            </div>
          </div>

          {/* <div className="col-xs-8 text-center">Meal Break Times</div> */}
          <div className="clear20"></div>
        </div>
        <div className="clear5"></div>
        <div className="clear20"></div>

        <div className="col-xs-12 profile_setting_pop p0 profile_setting_pop_5">
          <div className="clear70-wrap"></div>
          <div className="col-sm-12 p-0">
            <form className="form-horizontal">
              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Start MB1
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={startMB1}
                    format={format}
                    onChange={this.handleChangeDayTimeStartMeal}
                    id={`d_startMB1_add`}
                    onClick={() => this.fixOverflowIssue(`d_startMB1_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Finish MB1
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={finishMB1}
                    format={format}
                    onChange={this.handleChangeDayTimeFinishMeal1}
                    id={`d_finishMB1_add`}
                    onClick={() => this.fixOverflowIssue(`d_finishMB1_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Start MB2
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={startMB2}
                    format={format}
                    onChange={this.handleChangeDayTimeStartMeal2}
                    id={`d_startMB2_add`}
                    onClick={() => this.fixOverflowIssue(`d_startMB2_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Finish MB2
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={finishMB2}
                    format={format}
                    onChange={this.handleChangeDayTimeFinishMeal2}
                    id={`d_finishMB2_add`}
                    onClick={() => this.fixOverflowIssue(`d_finishMB2_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Start MB3
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={startMB3}
                    format={format}
                    onChange={this.handleChangeDayTimeStartMeal3}
                    id={`d_startMB3_add`}
                    onClick={() => this.fixOverflowIssue(`d_startMB3_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-4 form__lbl--one form__mx-wraper">
                  Finish MB3
                </label>
                <div className="col-xs-8">
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    minuteStep={minuteStep}
                    inputReadOnly={inputReadOnly}
                    allowEmpty={allowEmpty}
                    value={finishMB3}
                    format={format}
                    onChange={this.handleChangeDayTimeFinishMeal3}
                    id={`d_finishMB3_add`}
                    onClick={() => this.fixOverflowIssue(`d_finishMB3_add`)}
                    getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-6 form__lbl--one form__mx-wraper2">
                  Non Deductible MB1
                </label>
                <div className="col-xs-6" style={{ paddingTop: "10px" }}>
                  <input
                    type="checkbox"
                    name="nonDeductableMB1"
                    onChange={this.handleChangeDayTime}
                    checked={nonDeductableMB1}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-6 form__lbl--one form__mx-wraper2">
                  Non Deductible MB2
                </label>
                <div className="col-xs-6" style={{ paddingTop: "10px" }}>
                  <input
                    type="checkbox"
                    name="nonDeductableMB2"
                    onChange={this.handleChangeDayTime}
                    checked={nonDeductableMB2}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label className="control-label col-xs-6 form__lbl--one form__mx-wraper2">
                  Non Deductible MB3
                </label>
                <div className="col-xs-6" style={{ paddingTop: "10px" }}>
                  <input
                    type="checkbox"
                    name="nonDeductableMB3"
                    onChange={this.handleChangeDayTime}
                    checked={nonDeductableMB3}
                  />
                </div>
              </div>

              <div className="clear20"></div>
              <div className="flex__wrapper--four">
                <input
                  name=""
                  className="btn_save_pro btn_save_pro_5"
                  value="Save"
                  type="button"
                  onClick={() =>
                    this.handleSaveDayTime(dayTimeIndex, "DayTimes")
                  }
                  // onClick={() => this.handleSubView("DayTimes")}
                  disabled={isLoading}
                />
                <input
                  name=""
                  className="btn_cancel_pro nn"
                  value="Cancel"
                  type="button"
                  onClick={() => this.handleSubView("DayTimes")}
                />
              </div>
            </form>

            <div className="clear5"></div>

            <div className="clear40"></div>
            <div className="clear20"></div>
          </div>
        </div>
      </div>
    );
  };

  /**
   * Renders the popup for adding? and editing a single day
   * @param {number} index Used to identify the index of the day
   * @param {'DayTimes'|'Add'} subView From where this is being being called. 'Add' means it is being called from edit button that is at end of every row of the day table
   */
  handleDayTime = (index, subView) => {
    let table = window.$("#dailyTimes-table").DataTable();
    table.destroy();
    this.setState({selectedIndex: index});

    // During edit: dailyTimes will contain the advanceList for a selected date which can be accessed with advancedList[index]
    // During create: advancedList contains the advanceList for a selected date

    let { dailyTimes, format, dateFormat, standardDateFormat, advancedList } = this.state;

    let initialTime = moment("00:00", format);

    let day = dailyTimes[index];
    //setting the advanecd list
    let dailyTimeAdvancedList = day.advancedList || [];
    dailyTimeAdvancedList = _.cloneDeep(dailyTimeAdvancedList);
    let filtrdList = this.settingAdvancedList(
      "dtAdvancedList",
      dailyTimeAdvancedList
    );
    this.setState(
      {
        payAs: day.payAs ? day.payAs : "0",
        day: day.day,
        date: day.date,

        camCall: day.camCall ? moment(day.camCall, format) : initialTime,
        camCallType: day.camCall
          ? moment(day.camCall, format).format(format)
          : "00:00",

        camWrap: day.camWrap ? moment(day.camWrap, format) : initialTime,
        camWrapType: day.camWrap
          ? moment(day.camWrap, format).format(format)
          : "00:00",

        travelTo: day.travelTo ? moment(day.travelTo, format) : initialTime,
        travelToType: day.travelTo
          ? moment(day.travelTo, format).format(format)
          : "00:00",

        startWork: day.startWork ? moment(day.startWork, format) : initialTime,
        startWorkType: day.startWork
          ? moment(day.startWork, format).format(format)
          : "00:00",

        startMB1: day.startMB1 ? moment(day.startMB1, format) : initialTime,
        startMB1Type: day.startMB1
          ? moment(day.startMB1, format).format(format)
          : "00:00",

        finishMB1: day.finishMB1 ? moment(day.finishMB1, format) : initialTime,
        finishMB1Type: day.finishMB1
          ? moment(day.finishMB1, format).format(format)
          : "00:00",

        nonDeductableMB1:
          day.nonDeductableMB1 === "0" || day.nonDeductableMB1 === ""
            ? false
            : true,

        startMB2: day.startMB2 ? moment(day.startMB2, format) : initialTime,
        startMB2Type: day.startMB2
          ? moment(day.startMB2, format).format(format)
          : "00:00",

        finishMB2: day.finishMB2 ? moment(day.finishMB2, format) : initialTime,
        finishMB2Type: day.finishMB2
          ? moment(day.finishMB2, format).format(format)
          : "00:00",

        nonDeductableMB2:
          day.nonDeductableMB2 === "0" || day.nonDeductableMB2 === ""
            ? false
            : true,

        startMB3: day.startMB3 ? moment(day.startMB3, format) : initialTime,
        startMB3Type: day.startMB3
          ? moment(day.startMB3, format).format(format)
          : "00:00",

        finishMB3: day.finishMB3 ? moment(day.finishMB3, format) : initialTime,
        finishMB3Type: day.finishMB3
          ? moment(day.finishMB3, format).format(format)
          : "00:00",

        nonDeductableMB3:
          day.nonDeductableMB3 === "0" || day.nonDeductableMB3 === ""
            ? false
            : true,

        totalMB: day.totalMB ? moment(day.totalMB, format) : initialTime,
        totalMBType: day.totalMB
          ? moment(day.totalMB, format).format(format)
          : "00:00",

        finishWork: day.finishWork
          ? moment(day.finishWork, format)
          : initialTime,
        finishWorkType: day.finishWork
          ? moment(day.finishWork, format).format(format)
          : "00:00",

        travelFrom: day.travelFrom
          ? moment(day.travelFrom, format)
          : initialTime,
        travelFromType: day.travelFrom
          ? moment(day.travelFrom, format).format(format)
          : "00:00",

        // totalHours: day.totalHours ? day.totalHours : "00:00",
        dayTimeTotalHours: day.totalHours ? day.totalHours : "00:00",
        notes: day.notes ? day.notes : null,
        internalNotes: day.internalNotes ? day.internalNotes : null,
        saveDayTimeError: "",
        subView,
        dayTimeIndex: index,
        dayTimeCopyIndex: index,
        dayTimeDateMoment: day.date
          ? moment(this.dailyTimesDateFormat(day.date), dateFormat)
          : "",
        dayTimeDate: day.date
          ? moment(this.dailyTimesDateFormat(day.date), dateFormat).format(
              standardDateFormat
            )
          : "",
        dailyTimeAdvancedList: filtrdList,
        clonedDailyTimeAdvancedList: dailyTimeAdvancedList,
      },
      () => {
        this.updateTotalMBDedDisabledState();
        this.timecardTableSetting("#dailyTimes-table");
      }
    );

    if (subView === "Add") {
      $("#WeekTimesModalCenterBtn").click();
    }
  };

  // ############### END #############
  //Prime Timecard
  primeTimecard = async () => {
    /*
  PrimeTimecard should be called when the insert button is pressed. This will provide the tran no. for the attachments
  and InsertTimecard. InsertTimecard should be called for the first save to create the record.
  This requires the Employee Code and Tran. UpdateTimecard can be called after InsertTimecard to save any changes.
  */
    this.setState({ isLoading: true });
    await this.props.primeTimecard();

    let {
      tran,
      department,
      employeeCode,
      employeeName,
      approverGroup,
      approverOptions,
      position,
      totalHours,
      weekEndingDate,
      dailyTimes,
      attachments,
      advancedList,
      dailyTimeAdvancedList
    } = this.state;

    if (this.props.timecard.primeTimecardSuccess) {
      toast.success(this.props.timecard.primeTimecardSuccess);
      this.setState({ isPrimeTimeCardCreated: true });
      let primeTimecard = _.cloneDeep(this.props.timecard.primeTimecard);
      this.setState({ selectedGuid: primeTimecard.guid });
      tran = primeTimecard.tran || "";
      department = primeTimecard.department || "";
      employeeName = primeTimecard.employeeName || "";
      employeeCode = primeTimecard.employeeCode || "";
      approverGroup = primeTimecard.approverGroup || "";
      approverOptions = primeTimecard.approverOptions || [];
      position = primeTimecard.position || "";
      totalHours = primeTimecard.totalHours || "0.00";
      weekEndingDate = moment(parseInt(primeTimecard.weekEndingDate)) || "";
      dailyTimes = primeTimecard.dailyTimes || [];
      attachments = primeTimecard.attachments || [];
      advancedList = primeTimecard.advancedList || [];
      dailyTimeAdvancedList = primeTimecard.dailyAdvancedList || [];
      let obj = {
        'guid': primeTimecard.guid,
        'isEdited': true
      }
      let jsonString = JSON.stringify(obj);
      localStorage.setItem('lastPrimeTC', jsonString);
      dailyTimes.map(
        (t) =>
          (t.date = moment(parseInt(t.date)).format(
            this.state.standardDateFormat
          ))
      );

      approverOptions.map((a, i) => {
        a.label = a.option;
        a.value = a.option;
        return a;
      });
    } else if (this.props.timecard.primeTimecardError) {
      handleAPIErr(this.props.timecard.primeTimecardError, this.props);
    }
    let filtrdList = this.settingAdvancedList("tcAdvancedList", advancedList);
    const filteredDaylist = this.settingAdvancedList("dtAdvancedList", dailyTimeAdvancedList);

    this.setState(
      {
        tran,
        approverGroup,
        approverOptions,
        employeeName,
        employeeCode,
        department,
        position,
        totalHours,
        weekEndingDate,
        dailyTimes,
        attachments,
        advancedList: filtrdList,
        clonedAdvancedList: advancedList,
        dailyTimeAdvancedList: filteredDaylist,
        clonedDailyTimeAdvancedList: dailyTimeAdvancedList,
        isPrimed: true,
        isLoading: false,
      },
      () => {
        this.props.clearTimecardStates();
        this.setDailyTimes();
        this.timecardTableSetting("#timecard-advanced-list");
      }
    );
  };

  settingAdvancedList = (tableName, advancedList) => {
    //advanced list
    advancedList.map((lst, i) => {
      if (lst.valueType && lst.valueType.toLowerCase() === "list") {
        let valOptns = [];
        if (lst.valueOptions && lst.valueOptions.length > 0) {
          lst.valueOptions.map((o, i) => {
            valOptns.push({ label: o.option, value: o.option });
          });
        }
        lst.valueOptions = valOptns;
      }
      lst.id = uuidv1();
      return lst;
    });

    let filtrdList = [...advancedList];

    return filtrdList;
  };

  //get Timecard
  getTimecard = async (selectedGuid) => {
    this.setState({ isLoading: true });
    await this.props.getTimecard(selectedGuid);

    let {
      tran,
      department,
      employeeCode,
      employeeName,
      approverGroup,
      approverOptions,
      position,
      totalHours,
      weekEndingDate,
      dailyTimes,
      attachments,
      attachmentSize,
      advancedList,
    } = this.state;

    if (this.props.timecard.getTimecardSuccess) {
      toast.success(this.props.timecard.getTimecardSuccess);

      let getTimecard = _.cloneDeep(this.props.timecard.getTimecard);

      tran = getTimecard.tran || "";
      department = getTimecard.department || "";
      employeeName = getTimecard.employeeName || "";
      employeeCode = getTimecard.employeeCode || "";
      approverGroup = getTimecard.approverGroup || "";
      approverOptions = getTimecard.approverOptions || [];
      position = getTimecard.position || "";
      totalHours = getTimecard.totalHours || "";
      weekEndingDate = moment(parseInt(getTimecard.weekEndingDate)) || "";
      dailyTimes = getTimecard.dailyTimes || [];

      dailyTimes.map(
        (t) =>
          (t.date = moment(parseInt(t.date)).format(
            this.state.standardDateFormat
          ))
      );
      //dailyTimes.map((t) => (t.date = t.date / 1000));

      attachments = getTimecard.attachments || [];

      attachmentSize = 0;

      attachments.map((a, i) => {
        attachmentSize += Number(a.fileSize) || 0;
      });

      advancedList = getTimecard.advancedList || [];

      approverOptions.map((a, i) => {
        a.label = a.option;
        a.value = a.option;
        return a;
      });
    } else if (this.props.timecard.getTimecardError) {
      handleAPIErr(this.props.timecard.getTimecardError, this.props);
    }
    let filtrdList = this.settingAdvancedList("tcAdvancedList", advancedList);

    this.setState(
      {
        tran,
        approverGroup,
        approverOptions,
        employeeName,
        employeeCode,
        department,
        position,
        totalHours,
        weekEndingDate,
        dailyTimes,
        attachments,
        attachmentSize,
        advancedList: filtrdList,
        clonedAdvancedList: advancedList,
        isPrimed: false,
        isLoading: false,
      },
      () => {
        this.props.clearTimecardStates();
        this.timecardTableSetting("#timecard-advanced-list");
      }
    );
  };

  //update Timecard
  updateTimecard = async () => {
    this.setState({ isLoading: true, openUnsavedChangesModal: false });
    let {
      tran,
      department,
      employeeCode,
      approverGroup,
      position,
      totalHours,
      weekEndingDate,
      dailyTimes,
      attachments,
      advancedList,
      selectedGuid,
      selectedBatchNos,
      order
    } = this.state;

    let timecrd = {
      guid: selectedGuid,
      employeeCode,
      department,
      position,
      approverGroup,
      totalHours,
      // weekEndingDate: moment.unix(weekEndingDate).valueOf(),
      weekEndingDate: moment.utc(weekEndingDate).valueOf(),
      dailyTimes,
      attachments,
      advancedList,
    };
    await this.props.updateTimecard(timecrd);

    if (this.props.timecard.updateTimecardSuccess) {
      toast.success(this.props.timecard.updateTimecardSuccess);
      localStorage.removeItem('lastPrimeTC');
      /*Check When Add/Edit timecard and then user Save or Cancel that edit,
        then load the same  timecard user just edited/created?.*/

      let state =
        (this.props.history.location && this.props.history.location.state) ||
        "";
      let { tallies } = state;
      this.props.history.push("/timecards", {
        tallies,
        addEditTimecardCheck: true,
        addEditTimecardTran: tran,
        selectedGuid: selectedGuid,
        previouslyEdited: true,
        selectedBatchNos: selectedBatchNos,
        order: order
      });
    } else if (this.props.timecard.updateTimecardError) {
      handleAPIErr(this.props.timecard.updateTimecardError, this.props);
    }

    this.props.clearTimecardStates();
    this.setState({ isLoading: false });
  };

  //insert Timecard
  insertTimecard = async () => {
    this.setState({ isLoading: true });

    let {
      tran,
      department,
      employeeCode,
      approverGroup,
      position,
      totalHours,
      weekEndingDate,
      dailyTimes,
      attachments,
      advancedList,
      selectedGuid,
      selectedBatchNos,
      order
    } = this.state;

    let timecrd = {
      guid: selectedGuid,
      employeeCode,
      department,
      position,
      approverGroup,
      totalHours,
      // weekEndingDate: moment.unix(weekEndingDate).valueOf(),
      weekEndingDate: moment(weekEndingDate).valueOf(),
      dailyTimes,
      attachments,
      advancedList,
    };

    await this.props.insertTimecard(timecrd);

    if (this.props.timecard.insertTimecardSuccess) {
      // toast.success(this.props.timecard.insertTimecardSuccess);

      await this.props.getTimecardSummary(selectedGuid);
      //success case of Get Timecard Summary
      if (this.props.timecard.getTimecardSummarySuccess) {
        // toast.success(this.props.timecard.getTimecardSummarySuccess);
        let tcSummary = _.cloneDeep(this.props.timecard.getTimecardSummary);
        /*Check When Add/Edit timecard and then user Save or Cancel that edit,
      then load the same  timecard user just edited/created?.*/
        this.props.history.push("/timecards", {
          tallies: "Draft",
          addEditTimecardCheck: true,
          addEditTimecardTran: tran,
          guid: tcSummary.guid,
          activePage: this.state.activePage,
          timeCardAdded: true,
          previouslyEdited: true,
          selectedGuid:selectedGuid,
          selectedBatchNos: selectedBatchNos,
          order: order
        });
      }
    } else if (this.props.timecard.insertTimecardError) {
      handleAPIErr(this.props.timecard.insertTimecardError, this.props);
    }

    this.props.clearTimecardStates();
    this.setState({ isLoading: false });
  };

  openModal = (name, type) => {
    this.setState({ [name]: true });
  };

  onCancel = () => {
    /*Check When Add/Edit timecard and then user Save or Cancel that edit,
        then load the same  timecard user just edited/created?.*/

    let state =
      (this.props.history.location && this.props.history.location.state) || "";
    let { tallies, newTc } = state;

    if (newTc){
      this.setState({  openUnsavedChangesModal: false  })
      this.openModal('openDeleteModal')
      // this.deleteTimecard();
      localStorage.removeItem('lastPrimeTC');
    }else{
      this.props.history.push("/timecards", {
        tallies,
        addEditTimecardCheck: true,
        addEditTimecardTran: this.state.tran,
        guid: this.state.selectedGuid,
        selectedGuid:this.state.selectedGuid,
        previouslyEdited: true,
        isPrimeTimeCardCreated: this.state.isPrimeTimeCardCreated,
        selectedBatchNos: this.state.selectedBatchNos,
        order: this.state.order
      });
    }


  };

  deleteTimecard = async () => {
    await this.props.deleteTimecard(this.state.selectedGuid); // delete timecard
    if (this.props.timecard.deleteTimecardSuccess) {
      toast.success(this.props.timecard.deleteTimecardSuccess);
      this.props.history.push("/timecards", {
        previouslyEdited: true,
        isPrimeTimeCardCreated: this.state.isPrimeTimeCardCreated
      });
    }
    if (this.props.timecard.deleteTimecardError) {
      handleAPIErr(this.props.timecard.deleteTimecardError, this.props);
    }
  }
  handleCopyLastWeekTimes = async () => {
    let {
      weekEndingDate,
      tran,
      employeeCode,
      dailyTimes,
      totalHours,
      selectedGuid,
    } = this.state;
    let clonedWeekEndingDate = moment.utc(weekEndingDate).valueOf();

    if (this.state.weekEndingDate.length === 0) {
      toast.error("Please select period ending date.");
      return false;
    } else {
      let obj = {
        guid: selectedGuid,
        periodEnding: clonedWeekEndingDate,
        employeeCode,
      };
      this.setState({ isLoading: true });
      await this.props.copyLastWeeksTimes(obj);

      if (this.props.timecard.copyLastWeeksTimesSuccess) {
        toast.success(this.props.timecard.copyLastWeeksTimesSuccess);

        let copyLastWeeksTimesDailyTime =
          this.props.timecard.copyLastWeeksTimes.dailyTimes.map((item) => ({
            ...item,
            date: item.date,
          }));

        totalHours =
          this.props.timecard.copyLastWeeksTimes.totalHours || "0.00";

        dailyTimes = copyLastWeeksTimesDailyTime;
      } else {
        handleAPIErr(this.props.timecard.copyLastWeeksTimesError, this.props);
      }
      this.setState({
        dailyTimes,
        totalHours,
        isLoading: false,
      });
      this.props.clearTimecardStates();
    }
  };

  setDailyTimes = () => {
    let { payFrequency, weekEndingDate, clonedDailyTimeAdvancedList } = this.state;
    let subtractDays =
      payFrequency === "Monthly"
        ? 29
        : payFrequency === "Fortnightly"
        ? 13
        : payFrequency === "4 Weekly"
        ? 27
        : 6;
    let periodStarting = moment(weekEndingDate)
      .subtract(subtractDays, "days")
      .format("YYYY-MM-DD 00:00");
    let dailyTimes = [];
    periodStarting = moment(periodStarting);

    while (periodStarting <= weekEndingDate) {
      dailyTimes.push({
        payAs: "0",
        //date: Math.floor(periodStarting.valueOf() / 1000),
        date: periodStarting.format(this.state.standardDateFormat),
        day: periodStarting.format("dddd"),
        camCall: "00:00",
        camWrap: "00:00",

        travelTo: "00:00",
        startWork: "00:00",
        startMB1: "00:00",
        finishMB1: "00:00",
        nonDeductableMB1: "0",
        startMB2: "00:00",
        finishMB2: "00:00",
        nonDeductableMB2: "0",
        startMB3: "00:00",
        finishMB3: "00:00",
        nonDeductableMB3: "0",
        totalMB: "00:00",
        finishWork: "00:00",
        travelFrom: "00:00",
        totalHours: "00:00",
        pmtFlags: "",
        notes: null,
        advancedList: clonedDailyTimeAdvancedList
      });
      periodStarting.add(1, "days");
    }
    this.setState({ dailyTimes });
  };

  handlePeriodEnding = (value, dateString) => {
    this.setState(
      {
        weekEndingDate: value,
        totalHours: "00:00",
        isMobCalOpen: false,
        isWebCalOpen: false,
      },
      () => {
        this.changeOnDateInDailyTimes();
      }
    );
  };

  changeOnDateInDailyTimes = () => {
  let { payFrequency, weekEndingDate, dailyTimes, clonedDailyTimeAdvancedList } = this.state;
  const groupTimes = [];

  let subtractDays =
    payFrequency === "Monthly" ? 29 :
    payFrequency === "Fortnightly" ? 13 :
    payFrequency === "4 Weekly" ? 27 : 6;

  let periodStarting = moment.utc({
    year: weekEndingDate.year(),
    month: weekEndingDate.month(),
    date: weekEndingDate.date(),
    hour: 12,
    minute: 0,
    second: 0
  }).subtract(subtractDays, "days").startOf('day');

  let makeDailyTimes = [];

 
  if (dailyTimes.length === 0) {
    let currentDate = periodStarting.clone();

    while (currentDate.isSameOrBefore(weekEndingDate, 'day')) {
      const timeDetails = {
        payAs: "0",
        date: currentDate.format(this.state.standardDateFormat),
        day: currentDate.format("dddd"),
        camCall: "00:00",
        camWrap: "00:00",
        travelTo: "00:00",
        startWork: "00:00",
        startMB1: "00:00",
        finishMB1: "00:00",
        nonDeductableMB1: "0",
        startMB2: "00:00",
        finishMB2: "00:00",
        nonDeductableMB2: "0",
        startMB3: "00:00",
        finishMB3: "00:00",
        nonDeductableMB3: "0",
        totalMB: "00:00",
        finishWork: "00:00",
        travelFrom: "00:00",
        totalHours: "00:00",
        pmtFlags: "",
        notes: null,
        internalNotes: null,
        advancedList: clonedDailyTimeAdvancedList || []
      };
      groupTimes.push(timeDetails);
      currentDate.add(1, "days");
    }
  }

  let index = 1;
  let currentDate = periodStarting.clone();
  
  while (currentDate.isSameOrBefore(weekEndingDate, 'day')) {
    makeDailyTimes.push({
      index: index,
      date: currentDate.format(this.state.standardDateFormat),
      day: currentDate.format("dddd"),
    });
    currentDate.add(1, "days");
    index += 1;
  }


  let result = (dailyTimes.length > 0 ? dailyTimes : groupTimes).map((item, idx) => {
    const dateMapping = makeDailyTimes.find((data) => 
      data.index === (item.lineNo ? item.lineNo : idx + 1)
    );
    
    return { 
      ...item, 
      date: dateMapping ? dateMapping.date : item.date, 
      day: dateMapping ? dateMapping.day : item.day 
    };
  });

  this.setState({ dailyTimes: result });
};


  handlerDateChangeForIndividualLine = (e, i) => {
    let day = moment(e).format("dddd");

    let clonedDailyTimes = this.state.dailyTimes;
    if (i !== undefined) {
      clonedDailyTimes[i] = {
        ...clonedDailyTimes[i],
        date: e.format(this.state.standardDateFormat),
        day,
      };
    }
    this.setState({
      dailyTimes: clonedDailyTimes,
      date: e.format(this.state.standardDateFormat),
      day,
    });
  };

  fixOverflowIssue(anchorPoint) {
    const anchorPointElement = document.getElementById(`${anchorPoint}`);
    if (!anchorPointElement) {
      console.log('anchorPointElement with id [%s] not found', anchorPoint);
    }
    const dropDownSelector = `#${anchorPoint} + .ant-picker-suffix + div .ant-picker-dropdown`;
    setTimeout(() => {
      const elements = document.querySelectorAll(dropDownSelector);
      if (elements.length === 0) {
        console.log('elements with selector [%s] not found', dropDownSelector);
        return;
      }
      for (let index = 0; index < elements.length; index++) {
        const popupElement = elements[index];
        const top = 30;
        const left = 0;
        popupElement.style.top = `${top}px`;
        popupElement.style.left = `${left}px`;
      }
    }, 250);
  }

  // uplaod timecard attchments
  uploadAttachment = async (f) => {
    let { attachmentSize } = this.state;
    let fileList = [];
    let type = f[0].type;
    let name = f[0].name;
    let file = f[0];
    let size = f[0].size;
    if (type == "application/pdf") {
      if (size <= 10485760) {
        //10MB = 10485760 Bytes
        if (attachmentSize < 30932992) {
          //30932992  -> 29.5 MB
          if (Number(size) + Number(attachmentSize) < 30932992) {
            const result = await toBase64(file).catch((e) => e);
            if (result instanceof Error) {
              toast.error(result.message);
              return;
            } else {
              fileList.push({
                fileName: name,
                attachment: result.split(",")[1],
                fileBlob: file
              });
            }
          } else {
            let remaining_KBs = (30932992 - attachmentSize) / 1024; //available space
            remaining_KBs = Number(remaining_KBs).toFixed(2);
            toast.error(
              `You can upload a file of size ${remaining_KBs}KB, Attachmnents limit 29.5MB.`
            );
          }
        } else {
          toast.error(
            "You can't add more attachments. Attachments limit 29.5MB! "
          );
        }
      } else {
        toast.error(
          "This file exceeds the 10MB limit. Please upload a smaller file."
        );
      }
    } else {
      toast.error("Please Select only Attachments of type: 'pdf'");
    }


    if (f.length === fileList.length) {
      await this.addAttachment(fileList);
    }
  };

  //add attachment
  addAttachment = async (fileList) => {
    let { tran, attachments, attachmentSize, selectedGuid } = this.state;
    if (selectedGuid) {
      this.setState({ isLoading: true });
      let data = {
        fileName: fileList[0].fileName,
        attachment: fileList[0].attachment,
        guid: selectedGuid,
        documentGUID:"",
      };

      if (isRemoteStorage()) {
        await uploadFileListToS3(fileList, async (uploadedFiles) => {
          if (uploadedFiles) {
            let attachmentData = {
              guid: selectedGuid,
              fileName: uploadedFiles[0]?.fileName,
              documentGUID: uploadedFiles[0]?.documentGuid,
            }
            await this.props.addAttachment(attachmentData);
            if (this.props.timecard.addAttachmentsSuccess) {
              toast.success(this.props.timecard.addAttachmentsSuccess);
              let attachments = this.props.timecard.addAttachments || [];
              let attachmentSize = 0;
              attachments.map((a, i) => {
                attachmentSize += Number(a.fileSize) || 0;
              });
              this.setState({ attachments, attachmentSize });
            }
            if (this.props.timecard.addAttachmentsError) {
              handleAPIErr(this.props.timecard.addAttachmentsError, this.props);
            }
            this.props.clearTimecardStates();
            this.setState({ isLoading: false });
          }
        })}else {
        await this.props.addAttachment(data);
      }
      if (this.props.timecard.addAttachmentsSuccess) {
        toast.success(this.props.timecard.addAttachmentsSuccess);
        attachments = this.props.timecard.addAttachments || attachments;
        attachmentSize = 0;
        attachments.map((a, i) => {
          attachmentSize += Number(a.fileSize) || 0;
        });
      }
      if (this.props.timecard.addAttachmentsError) {
        handleAPIErr(this.props.timecard.addAttachmentsError, this.props);
      }
      this.setState({ isLoading: false, attachments, attachmentSize });
    } else {
      toast.error("Tran is missing!");
    }
  };

  deleteAttachment = async (recordID) => {
    let { attachments } = this.state;
    this.setState({ isLoading: true });
    await this.props.deleteAttachment(recordID);

    if (this.props.timecard.deleteAttachmentSuccess) {
      toast.success(this.props.timecard.deleteAttachmentSuccess);

      attachments = attachments.filter((att) => att.recordID !== recordID);
    }
    if (this.props.timecard.deleteAttachmentError) {
      handleAPIErr(this.props.timecard.deleteAttachmentError, this.props);
    }

    this.setState({ attachments, isLoading: false });

    this.props.clearTimecardStates();
  };

  getAttachment = async (recordID) => {
    this.setState({
      isLoading: true,
    });

    await this.props.getAttachment(recordID);
    this.setState({ isLoading: false });

    if (this.props.timecard.getAttachmentSuccess) {
      toast.success(this.props.timecard.getAttachmentSuccess);

      let attachment = this.props.timecard.getAttachment || "";
      if (attachment.downloadPresignedUrl) {
        downloadFileFromPresignedUrl(attachment.downloadPresignedUrl);
      }else {
        downloadAttachments(attachment, "timecard");
      }
    }

    if (this.props.timecard.getAttachmentError) {
      handleAPIErr(this.props.timecard.getAttachmentError, this.props);
    }
    this.props.clearTimecardStates();
  };

  updateParentState = (params) => {
    this.setState(
      {
        employeeCode: params.employeeCode,
        employeeName: params.firstName + " " + params.lastName,
        approverGroup: params.approverGroup,
        department: params.department,
        position: params.position,
      },
      async () => {
        await this.getEmployeeDetailsList();
      }
    );
  };

  handleChangeEmployeeName = async (e) => {
    $(".employee_name").show();
    let value = e.target.value;
    let clonedEmployeeList = [...this.state.employeeList];
    if (!value) {
      clonedEmployeeList = [];
    } else {
      let chartCodesListFilterdData = clonedEmployeeList.filter((c) => {
        return (
          c.firstName.toUpperCase().includes(value.toUpperCase()) ||
          c.lastName.toUpperCase().includes(value.toUpperCase())
        );
      });
      clonedEmployeeList = chartCodesListFilterdData;
    }

    this.setState({
      employeeName: value,
      clonedEmployeeList,
    });
  };

  changeEmployeeName = async (params) => {
    //focus after chart code selection to move next on Tab press
    $(`#employee_name_input`).focus();

    this.setState({
      employeeCode: params.employeeCode,
      employeeName: params.firstName + " " + params.lastName,
      approverGroup: params.approverGroup,
      department: params.department,
      position: params.position,
    });
  };

  onblur = (i) => {
    setTimeout(() => {
      $(".employee_name").hide();
    }, 700);
  };

  refreshEmployees = async () => {
    let { employeeList } = this.state;
    this.setState({
      isLoading: true,
    });

    await this.props.refreshEmployees();

    if (this.props.timecard.refreshEmployeesSuccess) {
      toast.success(this.props.timecard.refreshEmployeesSuccess);
      employeeList = this.props.timecard.refreshEmployees || [];
    }
    if (this.props.timecard.refreshEmployeesError) {
      handleAPIErr(this.props.timecard.refreshEmployeesError, this.props);
    }
    this.setState({
      isLoading: false,
      employeeList,
      clonedEmployeeList: employeeList,
    });
    this.props.clearTimecardStates();
  };

  getEmployeeList = async () => {
    let { employeeList } = this.state;
    this.setState({ isLoading: true });
    await this.props.getEmployeeList();

    if (this.props.timecard.getEmployeeListSuccess) {
      // toast.success(this.props.timecard.getTimecardListSuccess);
      employeeList = this.props.timecard.getEmployeeList || [];
    }
    if (this.props.timecard.getEmployeeListError) {
      handleAPIErr(this.props.timecard.getEmployeeListError, this.props);
    }
    this.setState({
      employeeList: employeeList,
      clonedEmployeeList: employeeList,
    });
    this.props.clearTimecardStates();
    this.setState({ isLoading: false });
  };
  // Advanced List Start

  timecardTableSetting = (tableName) => {
    window.$(tableName).DataTable({
      dom: "Rlfrtip",
      searching: false,
      paging: false,
      info: false,
      order: [[1, "asc"]],
      colReorder: {
        fixedColumnsRight: 5,
        fixedColumnsLeft: 5,
      },
    });
  };

  //handle Advanced list values Timecard
  handleValueOptions = async (type, val, item, index) => {
    let { advancedList, clonedAdvancedList } = this.state;
    let result = handleValueOptions(
      type,
      val,
      item,
      index,
      advancedList,
      clonedAdvancedList
    );
    this.setState(result);
  };

  //handle Advanced list values Daily Times
  handleValueOptionsDailyTimes = async (type, val, item, index) => {
    let { dailyTimeAdvancedList, clonedDailyTimeAdvancedList } = this.state;

    let result = handleValueOptions(
      type,
      val,
      item,
      index,
      dailyTimeAdvancedList,
      clonedDailyTimeAdvancedList
    );

    dailyTimeAdvancedList = result.advancedList;
    clonedDailyTimeAdvancedList = result.clonedAdvancedList;

    this.setState({ dailyTimeAdvancedList, clonedDailyTimeAdvancedList });
  };

  //show hidden rows timecard

  handleShowHiddenRows = async () => {
    let table = window.$("#timecard-advanced-list").DataTable();
    table.destroy();
    this.setState(
      (state) => ({
        showHiddenRows: !state["showHiddenRows"],
      }),
      () => {
        let { showHiddenRows } = this.state;
        if (showHiddenRows) {
          //show hidden rows
          let clonedAdvancedList = this.state.clonedAdvancedList;
          this.setState({ advancedList: clonedAdvancedList }, () => {
            this.timecardTableSetting("#timecard-advanced-list");
          });
        } else {
          let advancedList = this.state.advancedList;
          let list = [...advancedList];
          this.setState({ advancedList: list }, () => {
            this.timecardTableSetting("#timecard-advanced-list");
          });
        }
      }
    );
  };
  //show hidden rows daily times
  showHiddenRowsDailyTime = async () => {
    let table = window.$("#dailyTimes-table").DataTable();
    table.destroy();
    this.setState(
      (state) => ({
        showHiddenRowsDailyTime: !state["showHiddenRowsDailyTime"],
      }),
      () => {
        let { showHiddenRowsDailyTime, clonedDailyTimeAdvancedList } =
          this.state;
        if (showHiddenRowsDailyTime) {
          //show hidden rows
          this.setState(
            { dailyTimeAdvancedList: clonedDailyTimeAdvancedList },
            () => {
              this.timecardTableSetting("#dailyTimes-table");
            }
          );
        } else {
          let { dailyTimeAdvancedList } = this.state;
          let list = [...dailyTimeAdvancedList];
          this.setState({ dailyTimeAdvancedList: list }, () => {
            this.timecardTableSetting("#dailyTimes-table");
          });
        }
      }
    );
  };

  updateTotalMBDedDisabledState = () => {
    //totalMBDedDisabled
    let {
      startMB1,
      startMB2,
      startMB3,
      finishMB1,
      finishMB2,
      finishMB3,
      totalMBDedDisabled,
    } = this.state;

    if (
      startMB1.format("HH:mm") === "00:00" &&
      startMB2.format("HH:mm") === "00:00" &&
      startMB3.format("HH:mm") === "00:00" &&
      finishMB1.format("HH:mm") === "00:00" &&
      finishMB2.format("HH:mm") === "00:00" &&
      finishMB3.format("HH:mm") === "00:00"
    ) {
      totalMBDedDisabled = false;
    } else {
      totalMBDedDisabled = true;
    }
    this.setState({ totalMBDedDisabled });
  };

  inputHandlerChangeFeild = (e, i) => {
    let clonesDailyTime = this.state.dailyTimes;
    let item;
    if (i !== undefined) {
      item = {
        ...clonesDailyTime[i],
        advancedList: [...clonesDailyTime[i].advancedList],
        [e.target.name]: e.target.value,
      };
    }
    let result = this.updateDailyTimesItem(i, item)
    this.setState({
       dailyTimes: result,
      [e.target.name]: e.target.value,
    });
  };

  checkBoxHandler = (e, i) => {
    let clonedDailyTimes = this.state.dailyTimes;
    if (i !== undefined) {
      clonedDailyTimes[i] = {
        ...clonedDailyTimes[i],
        checked: e.target.checked,
      };
    } else {
      this.setState({ checkAll: e.target.checked });
      clonedDailyTimes = clonedDailyTimes.map((item) => ({
        ...item,
        checked: e.target.checked,
      }));
    }
    this.setState({ dailyTimes: clonedDailyTimes });
  };

  clearPmtTages = (e) => {
    e.preventDefault();
    let clonesDailyTime = this.state.dailyTimes;
    clonesDailyTime = clonesDailyTime = clonesDailyTime.map((item) => {
      if (item.checked) {
        return { ...item, pmtFlags: "" };
      } else {
        return item;
      }
    });

    this.setState(
      {
        dailyTimes: clonesDailyTime,
      },
      () => {
        this.clearTimeCardStats();
      }
    );
  };

  zeroHours = (e) => {
    e.preventDefault();
    let clonesDailyTime = _.cloneDeep(this.state.dailyTimes);

    clonesDailyTime = clonesDailyTime.map((item) => {
      if (item.checked) {
        return {
          ...item,
          camCall:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          camWrap:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          travelTo:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          startWork:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          startMB1: moment("00:00", "HH:mm"),
          finishMB1: moment("00:00", "HH:mm"),
          nonDeductableMB1: false,
          startMB2: moment("00:00", "HH:mm"),
          finishMB2: moment("00:00", "HH:mm"),
          nonDeductableMB2: false,
          startMB3: moment("00:00", "HH:mm"),
          finishMB3: moment("00:00", "HH:mm"),
          nonDeductableMB3: false,
          totalMB:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          finishWork:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          travelFrom:
            this.state.timecardEntry === "Text"
              ? "00:00"
              : moment("00:00", "HH:mm"),
          totalHours: "00.00",
        };
      } else {
        return item;
      }
    });
    this.setState(
      {
        dailyTimes: clonesDailyTime,
      },
      () => {
        this.updateTotalHours();
        this.clearTimeCardStats();
      }
    );
  };

  addDailyTimesRow = (e) => {
    let previousDailyTimes = this.state.dailyTimes;
    let day = moment(this.state.weekEndingDate).format("dddd");
    previousDailyTimes.push({
      checked: false,
      payAs: "Worked",
      date: this.state.weekEndingDate.format(this.state.standardDateFormat),
      day: day,
      camCall: "00:00",
      camWrap: "00:00",
      travelTo: "00:00",
      startWork: "00:00",
      startMB1: "00:00",
      finishMB1: "00:00",
      nonDeductableMB1: false,
      startMB2: "00:00",
      finishMB2: "00:00",
      nonDeductableMB2: false,
      startMB3: "00:00",
      finishMB3: "00:00",
      nonDeductableMB3: false,
      totalMB: "00:00",
      finishWork: "00:00",
      travelFrom: "00:00",
      totalHours: "0.00",
      pmtFlags: "",
      notes: "",
      internalNotes:""
    });
    this.setState({
      dailyTimes: previousDailyTimes,
    });
  };

  delteSelctedDailyTimesRow = (e) => {
    let filterdRowsWhichisNotChecked = this.state.dailyTimes.filter(
      (item) => !item.checked || item.checked === undefined
    );

    if (filterdRowsWhichisNotChecked.length === this.state.dailyTimes.length) {
      alert("select atleast one row");
      return;
    } else {
      this.setState(
        {
          dailyTimes: filterdRowsWhichisNotChecked,
        },
        () => {
          this.updateTotalHours();
        }
      );
    }
  };

  calculateDayHandler = (time, index) => {
    this.setState({ openCalculateDayModal: true }, () => {
      this.setState({
        dayCalculateData: time,
      });
    });
  };

  closeCalculateModal = async () => {
    let { tran, selectedGuid } = this.state;
    this.setState({ openCalculateDayModal: false, dayCalculateData: "" });
    let table = await window.$("#timecard-advanced-list").DataTable();
    await table.destroy();
    await this.getTimecard(selectedGuid);
  };

  dailyTimesDateFormat(date) {
    if (typeof date === "number") {
      return moment(date).format(this.state.dateFormat);
    } else {
      //return moment(new Date(date)).format(this.state.dateFormat);
      return moment(date, this.state.standardDateFormat).format(
        this.state.dateFormat
      );
    }
  }

  renderDailyTimesList = (dailyTimes, view) => {
    let {
      dateFormat,
      inputReadOnly,
      allowEmpty,
      format,
      totalMBDedDisabled,
    } = this.state;
    if (view === "mobile") {
      return dailyTimes && dailyTimes.map((time, i) => (
        <tr
          key={i}
          style={{ cursor: "pointer" }}
          onClick={() => this.handleDayTime(i, "DayTimes")}
        >
          <td align="center">{this.dailyTimesDateFormat(time.date)}</td>
          <td align="center">{time.day}</td>
          <td align="center">{time.totalHours}</td>
          <td align="center" style={{ paddingTop: "12px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="-4690 1327 10 16.19"
            >
              <path
                id="ic_chevron_right_24px"
                className="cls-1"
                d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                transform="translate(-4698.59 1321)"
              ></path>
            </svg>
          </td>
        </tr>
      ));
    } else {
      return dailyTimes && dailyTimes.map((time, i) => (
        <tr key={i}>
          <td align="center">
            <div className="form-group remember_check pt-0">
              <input
                type="checkbox"
                id={`editOrder ${i}`}
                checked={time.checked !== undefined ? time.checked : false}
                onChange={(e) => this.checkBoxHandler(e, i)}
                // onChange={(e) => this.handleCheckboxesInOrderDetails(e, "all")}
              />
              <label htmlFor={`editOrder ${i}`} className="mr-0"></label>
            </div>
          </td>
          <td align="center">
            <RDatePicker
              selected={moment(this.dailyTimesDateFormat(time.date), dateFormat)?.toDate() || new Date()}
              onChange={(e) => {
                const momentInstance = moment(e);
                this.handlerDateChangeForIndividualLine(momentInstance, i);
              }}
              dateFormat={dateFormat?.replace(/D/g, 'd')?.replace(/Y/g, 'y')}
              className="clndr-select no-border"
              showIcon={false}
              wrapperClassName="hide-calendar-icon"
            ></RDatePicker>
          </td>
          <td align="center">{time.day}</td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i, "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.camCall, format)}
                format={format}
                onChange={(moment, time) =>
                  this.handleChangeCamCallTime(moment, time, i)
                }
                id={`d_camCall_${i}`}
                onClick={() => this.fixOverflowIssue(`d_camCall_${i}`)}
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={time.camCall == "00:00" ? "" : time.camCall}
                placeholder="00:00"
                name="camCall"
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i, "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.camWrap, format)}
                format={format}
                id={`d_camWrap_${i}`}
                onClick={() => this.fixOverflowIssue(`d_camWrap_${i}`)}
                onChange={(moment, time) =>
                  this.handleChangeCamWrapTime(moment, time, i)
                }
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={time.camWrap == "00:00" ? "" : time.camWrap}
                placeholder="00:00"
                name="camWrap"
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i, "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.travelTo, format)}
                format={format}
                id={`d_travelTo_${i}`}
                onClick={() => this.fixOverflowIssue(`d_travelTo_${i}`)}
                onChange={(m, t) =>
                  this.handleChangeDayToTravel(m, t, i, false)
                }
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={time.travelTo === "00:00" ? "" : typeof time.travelTo === 'string' ? 
                  time.travelTo : 
                  time.travelTo?.format('HH:mm')}
                placeholder="00:00"
                name="travelTo"
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i, "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.startWork, format)}
                id={`d_startWork_${i}`}
                onClick={() => this.fixOverflowIssue(`d_startWork_${i}`)}
                format={format}
                onChange={(time, timeString) => this.handleChangeDayTimeStartInline(time, timeString, i)}
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={time.startWork == "00:00" ? "" : time.startWork}
                placeholder="00:00"
                name="startWork"
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i , "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.totalMB, format)}
                id={`d_totalMB_${i}`}
                onClick={() => this.fixOverflowIssue(`d_totalMB_${i}`)}
                format={format}
                onChange={(time, timeString) => this.handleChangeDayTimeTotalMBDedInline(time, timeString, i)}
                disabled={totalMBDedDisabled}
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={time.totalMB == "00:00" ? "" : time.totalMB}
                placeholder="00:00"
                name="totalMB"
                disabled={totalMBDedDisabled}
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i, "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                id={`d_finishWork_${i}`}
                onClick={() => this.fixOverflowIssue(`d_finishWork_${i}`)}
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.finishWork, format)}
                format={format}
                onChange={(time, timeString) => this.handleChangeDayTimeFinishInline(time, timeString, i)}
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={time.finishWork == "00:00" ? "" : time.finishWork}
                placeholder="00:00"
                name="finishWork"
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td
            align="center"
            onKeyDown={() => this.handleDayTimeInline(i, "Add")}
            className="custom--width"
          >
            {this.state.timecardEntry !== "Text" ? (
              <TimePicker
                showNow={false}
                allowClear={false}
                // minuteStep={minuteStep}
                minuteStep={
                  this.state.timecardInterval ? this.state.timecardInterval : 1
                }
                className="text_inline"
                inputReadOnly={inputReadOnly}
                allowEmpty={allowEmpty}
                value={moment(time.travelFrom, format)}
                format={format}
                id={`d_travelFrom_${i}`}
                onClick={() => this.fixOverflowIssue(`d_travelFrom_${i}`)}
                onChange={(m, t) =>
                  this.handleChangeDayFromTravel(m, t, i, false)
                }
                getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
              />
            ) : (
              <input
                type="text"
                className="text_inline_note"
                value={
                  time.travelFrom === "00:00" ? 
                  "" : 
                  typeof time.travelFrom === 'string' ? 
                    time.travelFrom : 
                    time.travelFrom?.format('HH:mm')
                  }
                placeholder="00:00"
                name="travelFrom"
                onChange={(e) => this.handleChangeDayTimeTypeInline(e, i)}
                onBlur={(e) => this.updateTimeTypeInline(e, i, false)}
              />
            )}
          </td>
          <td align="center">{time.totalHours}</td>
          <td align="center">
            {/* <input type="text" className="text_pmt-flag" /> */}
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="1"
              name="pmtFlags"
              value={time.pmtFlags}
              onChange={(e) => this.inputHandlerChangeFeild(e, i)}
            ></textarea>
          </td>
          <td align="center">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea12"
              rows="1"
              name="notes"
              value={time.notes}
              onChange={(e) => this.inputHandlerChangeFeild(e, i)}
            ></textarea>
          </td>
          <td align="center">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea12"
              rows="1"
              name="internalNotes"
              value={time.internalNotes}
              onChange={(e) => this.inputHandlerChangeFeild(e, i)}
            ></textarea>
          </td>
          <td align="center">
            <div className="flex__wrapper-time">
              <div className="text-center timecard_edit6">
                <a
                  href="javascript:void(0)"
                  onClick={() => this.handleDayTime(i, "Add")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="1656.776 299 17.515 18.003"
                  >
                    <path
                      id="ic_create_24px2"
                      className="cls-1"
                      d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                      transform="translate(1653.776 296.002)"
                    />
                  </svg>
                </a>
              </div>
              <div>
                <button
                  onClick={() => this.calculateDayHandler(time, i)}
                  className="btn"
                >
                  <i className="fa fa-calculator"></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
      ));
    }
  };

  formatDateWithoutTimeZone = (timestamp) => {
    if(!timestamp) return null;
    const date = new Date(timestamp);
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
   const utcDate = new Date(date.getTime() + userTimezoneOffset);
   return utcDate;
  }

  //Advanced List End
  renderAddView = (view) => {
    let {
      employeeName,
      department,
      position,
      weekEndingDate,
      approverGroup,
      approverOptions,
      dateFormat,
      isWebCalOpen,
      isPrimed,
      attachments,
      advancedList,
      showHiddenRows,
      clonedEmployeeList,
      totalHours,
      dailyTimes,
      dailyTimesCopyIndex,
    } = this.state;
    if (view === "mobile") {
      return (
        <div className="col-xs-12 col-sm-12 col-md-12  time_table_mrg_res">
          <div className="res_top_timecard ">
            <div className="form__inner-flex">
              <div className="col-xs-4 chev_res_let">
                <a
                  className="svg__icons1"
                  href="javascript:void(0)"
                  onClick={() => this.handleSubView("ListMobile", "Yes")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="2398 1881 13 19.418"
                  >
                    <path
                      id="ic_chevron_left_24px"
                      className="cls-1"
                      d="M21,8.282,18.526,6,8,15.709l10.526,9.709L21,23.136l-8.035-7.427Z"
                      transform="translate(2390 1875)"
                    ></path>
                  </svg>
                </a>{" "}
              </div>
              <div className="col-xs-8 text-center text--wrapper--one">
                <div>Digital Timesheet</div>
              </div>
            </div>
            <div className="clear20"></div>
          </div>

          <div className="clear70-wrap"></div>

          <div className="col-xs-12 profile_setting_pop p0 profile_setting_pop_5">
            <div className="clear5"></div>

            <form className="form-horizontal">
              <div className="form-group form__inner-flex ">
                <label className="control-label label__wrapper1 form__lbl--one">
                  Employee Name:
                </label>
                <div className="label__wrapper2">
                  <div className="custon_select">
                    <div className="modal_input">
                      <input
                        type="text"
                        className={
                          "form-control focus_employee border__one-wrapper"
                        }
                        placeholder="Employee Name"
                        id="employee_name_input"
                        autoComplete="off"
                        name="employeeName"
                        onChange={this.handleChangeEmployeeName}
                        onBlur={this.onblur}
                        readOnly
                        value={employeeName}

                        // onChange={() => {
                        //   $(".invoice_vender_menu1").show();
                        // }}
                      />

                      <span
                        onClick={() =>
                          {
                            this.getEmployeeList().then(() => {
                              this.setState({ openEmployeeLookupModal: true });
                            });
                          }
                        }
                        className="input_field_icons padding__right-20"
                      >
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                    <div
                      className={`chart_menue employee_name line_item_chart_menue`}
                    >
                      {clonedEmployeeList.length > 0 ? (
                        <ul className="invoice_vender_menu">
                          {clonedEmployeeList.map((c, i) => {
                            return (
                              <li
                                className="cursorPointer"
                                key={i}
                                onClick={() => this.changeEmployeeName(c)}
                              >
                                <div className="vender_menu_right chart_new">
                                  <h3 className="chart_vender_text">
                                    {c.firstName + " " + c.lastName}
                                    {}
                                  </h3>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <div className="sup_nt_fnd text-center">
                          <h6>No Employee Name Found</h6>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group form__inner-flex ">
                <label className="control-label label__wrapper1 form__lbl--one">
                  Approver Group:
                </label>
                <div className="label__wrapper2">
                  <Select
                    className="width-selector border__one-wrapper border__bottom-wrapper"
                    value={{
                      label: approverGroup,
                      value: approverGroup,
                    }}
                    options={approverOptions}
                    // classNamePrefix="custon_select-selector-inner"
                    styles={_customStyles}
                    classNamePrefix="react-select"
                    onChange={(g) => this.setState({ approverGroup: g.value })}
                    theme={(theme) => ({
                      ...theme,
                      border: 0,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "#f2f2f2",
                        primary: "#f2f2f2",
                      },
                    })}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex ">
                <label className="control-label label__wrapper12 form__lbl--one">
                  Period Ending Huhhhhh:
                </label>
                <div className="margin__wrapper--right">
                   <RDatePicker
                  selected={
                    weekEndingDate 
                      ? new Date(weekEndingDate.format('YYYY-MM-DD') + 'T12:00:00.000Z')
                      : weekEndingDate
                  }
                  onChange={(date) => {
                    if (date) {
                      console.log('Raw date from picker:', date);
                    
                      const year = date.getFullYear();
                      const month = date.getMonth();
                      const day = date.getDate();
                      
                      const selectedMoment = moment.utc({
                        year,
                        month,
                        date: day,
                        hour: 12,
                        minute: 0,
                        second: 0
                      });
                      
                      this.handlePeriodEnding(selectedMoment);
                    }
                  }}
                  dateFormat="dd/MM/yyyy"
                  className="clndr-select"
                  wrapperClassName="col-md-3 col-sm-3 mr-4 px-0"
                />
                </div>
              </div>

              <div className="form-group form__inner-flex ">
                <label
                  className="control-label label__wrapper1 form__lbl--one"
                  htmlFor="Dept"
                >
                  Department:
                </label>
                <div className="label__wrapper2">
                  <input
                    className="form-control pro_input_pop"
                    type="text"
                    id="department"
                    name="department"
                    defaultValue={department}
                    onBlur={this.handleChangeField}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label label__wrapper1 form__lbl--one"
                  htmlFor="Position"
                >
                  Position:
                </label>
                <div className="label__wrapper2">
                  <input
                    className="form-control pro_input_pop"
                    type="text"
                    id="position"
                    name="position"
                    defaultValue={position}
                    onBlur={this.handleChangeField}
                  />
                </div>
              </div>

              <div className="clearfix"></div>
            </form>

            <div className="clear5"></div>
            <div className="col-xs-12 p0 btn_time_time2_svg position-relative-wrapper">
              <input
                name=""
                className="btn_time_time2"
                value={
                  weekEndingDate !== ""
                    ? "Times " + totalHours + " Hrs"
                    : "Times 00:00 Hrs"
                }
                type="button"
                onClick={() => this.handleSubView("WeekTimes")}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-4690 1327 10 16.19"
              >
                <path
                  id="ic_chevron_right_24px"
                  className="cls-1"
                  d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                  transform="translate(-4698.59 1321)"
                />
              </svg>
            </div>
            <div className="clear5"></div>

            <div className="col-sm-12 p-0">
              <div className="heading_1">Attachment</div>

              <div className="col-12 mt-2">
                <div className="form-group custon_select border text-center mb-0 border-rad-5">
                  <div id="drop-area">
                    <input
                      type="file"
                      id="fileElem-attach"
                      className="form-control d-none"
                      accept="application/pdf"
                      onChange={(e) => {
                        this.uploadAttachment(e.target.files);
                      }}
                      onClick={(event) => {
                        event.currentTarget.value = null;
                      }} //to upload the same file again
                    />
                    <label className="upload-label" htmlFor="fileElem-attach">
                      <div className="upload-text">
                        <img
                          src="images/drag-file.png"
                          className="import_icon img-fluid"
                          alt="upload-attachment"
                        />
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <div className="clear10"></div>
              <div className="flex__wrapper--four">
                <input
                  name=""
                  className="btn_submit_res3 pull-right mr__right-wrapper"
                  type="button"
                  value="Save"
                  // onClick={() => {
                  //   isPrimed ? this.insertTimecard() : this.updateTimecard();
                  // }}
                  onClick={() => this.updateTimecard()}
                />

                <input
                  name=""
                  className="btn_save_res3 pull-right"
                  type="button"
                  value={"Cancel"}
                  onClick={this.onCancel}
                />
              </div>
              <div className="clear40"></div>
              <div className="clear20"></div>
            </div>
          </div>

          <div className="clear40"></div>
        </div>
      );
    } else {
      return (
        <div className="col-xs-12 col-sm-12 col-md-12 time_table_mrg">
          <div className="heading_1">Digital Timesheet</div>
          <div className="clear20"></div>

          <div className="col-sm-12 profile_setting_pop p0">
            <form className="form-horizontal mtop-wrapper">
              <div className="form-group form__inner-flex">
                <label className="control-label col-sm-4 col-md-3  col__label--wrapper form__lbl--one">
                  Employee Name:
                </label>
                <div className="col-sm-7 col-md-4  col__mx--100 period_ending">
                  <div className="custon_select">
                    <div className="modal_input">
                      <input
                        type="text"
                        className={
                          "form-control focus_employee border__one-wrapper"
                        }
                        placeholder="Employee Name"
                        id="employee_name_input"
                        autoComplete="off"
                        name="employeeName"
                        onChange={this.handleChangeEmployeeName}
                        onBlur={this.onblur}
                        value={employeeName}
                        readOnly
                        // onChange={() => {
                        //   $(".invoice_vender_menu1").show();
                        // }}
                      />

                      <span
                        onClick={() =>
                        {
                          this.getEmployeeList().then(() => {
                            this.setState({ openEmployeeLookupModal: true })
                          });
                        }
                        }
                        className="input_field_icons padding__right-20"
                      >
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                    <div
                      className={`chart_menue employee_name line_item_chart_menue`}
                    >
                      {clonedEmployeeList.length > 0 ? (
                        <ul className="invoice_vender_menu">
                          {clonedEmployeeList.map((c, i) => {
                            return (
                              <li
                                className="cursorPointer"
                                key={i}
                                onClick={() => this.changeEmployeeName(c)}
                              >
                                <div className="vender_menu_right chart_new">
                                  <h3 className="chart_vender_text">
                                    {c.firstName + " " + c.lastName}
                                    {}
                                  </h3>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <div className="sup_nt_fnd text-center">
                          <h6>No Employee Name Found</h6>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group form__inner-flex">
                <label className="control-label col-sm-4 col-md-3 col__label--wrapper form__lbl--one">
                  Approver Group:
                </label>

                <div className="col-sm-7 col-md-4  col__mx--100 form-group custon_select custom_selct2">
                  <Select
                    className="width-selector border__one-wrapper border__bottom-wrapper"
                    value={{
                      label: approverGroup,
                      value: approverGroup,
                    }}
                    options={approverOptions}
                    // classNamePrefix="custon_select-selector-inner"
                    styles={_customStyles}
                    classNamePrefix="react-select"
                    onChange={(g) => this.setState({ approverGroup: g.value })}
                    theme={(theme) => ({
                      ...theme,
                      border: 0,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "#f2f2f2",
                        primary: "#f2f2f2",
                      },
                    })}
                  />
                </div>
              </div>
              <div className="form-group form__inner-flex">
                <label className="control-label col-sm-4 col-md-3 col__label--wrapper form__lbl--one">
                  Period Ending:
                </label>
                <div className="col-sm-4 col-md-9 period_ending flex__wrap--one">
                <RDatePicker
                  selected={
                    weekEndingDate 
                      ? new Date(weekEndingDate.format('YYYY-MM-DD') + 'T12:00:00.000Z')
                      : weekEndingDate
                  }
                  onChange={(date) => {
                    if (date) {
                      console.log('Raw date from picker:', date);
                      
                      const year = date.getFullYear();
                      const month = date.getMonth();
                      const day = date.getDate();
                      
                      const selectedMoment = moment.utc({
                        year,
                        month,
                        date: day,
                        hour: 12,
                        minute: 0,
                        second: 0
                      });

                      
                      this.handlePeriodEnding(selectedMoment);
                    }
                  }}
                  dateFormat="dd/MM/yyyy"
                  className="clndr-select"
                  wrapperClassName="col-md-3 col-sm-3 mr-4 px-0"
                />
                  <button
                    type="button"
                    href="#"
                    className="btn_copy_time"
                    onClick={this.handleCopyLastWeekTimes}
                  >
                    <span>Copy Last Weeks Times</span>
                  </button>
                </div>
                {/* <div className="col-sm-4 col-md-3 ">

                </div> */}
                {/* <div className="col-sm-1 col-md-1 calendar_time2 timecard_cldr2 calednr__icon cl__icon-wrapper-three">
                </div> */}
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-sm-4 col-md-3 col__label--wrapper form__lbl--one"
                  htmlFor="department"
                >
                  Department:
                </label>
                <div className="col-sm-7 col-md-4  col__mx--100">
                  <input
                    className="form-control pro_input_pop"
                    type="text"
                    id="department"
                    name="department"
                    defaultValue={department}
                    onBlur={this.handleChangeField}
                  />
                </div>
              </div>

              <div className="form-group form__inner-flex">
                <label
                  className="control-label col-sm-4 col-md-3 col__label--wrapper form__lbl--one"
                  htmlFor="position"
                >
                  Position:
                </label>
                <div className="col-sm-7 col-md-4  col__mx--100">
                  <input
                    className="form-control pro_input_pop"
                    type="text"
                    id="position"
                    name="position"
                    defaultValue={position}
                    onBlur={this.handleChangeField}
                  />
                </div>
              </div>

              <div className="clear20"></div>
            </form>
          </div>
          <div className="clear10"></div>
          <div>
            <div className="col-md-12 p-0">
              <div className=" d-flex justify-content-end s-c-main icon_pad_top">
                <button
                  className="new_poedit_add_btn btn__plus--wrapper"
                  type="button"
                  tabIndex="2231"
                  id="id_save111"
                  onClick={this.addDailyTimesRow}
                >
                  <i
                    className="fa fa-plus icon--font_20"
                    aria-hidden="true"
                  ></i>
                  {/* <img
                                        src="images/plus-round.png"
                                        className="btn img-fluid float-right pr-0"
                                        alt="user"
                                      /> */}
                </button>
                <button
                  className="new_poedit_add_btn btn__plus--wrapper"
                  type="button"
                  tabIndex="2231"
                  id="id_save111"
                  onClick={this.delteSelctedDailyTimesRow}
                >
                  <i
                    className="fa fa-trash icon--font_20"
                    aria-hidden="true"
                  ></i>
                  {/* <img
                                        src="images/plus-round.png"
                                        className="btn img-fluid float-right pr-0"
                                        alt="user"
                                      /> */}
                </button>
              </div>
            </div>
          </div>
          <table className="table table-bordered table-sm timecard2_table">
            <thead>
              <tr>
                <th width="3%" align="center" className="timecrd-tbl-innerth">
                  <div className="form-group remember_check pt-0">
                    <input
                      type="checkbox"
                      id="checkAllDailtyTimes"
                      checked={
                        this.state.checkAll ? this.state.checkAll : false
                      }
                      onChange={(e) => this.checkBoxHandler(e)}
                      // onChange={(e) =>
                      //   this.handleCheckboxesInOrderDetails(e, "all")
                      // }
                    />
                    <label
                      htmlFor="checkAllDailtyTimes"
                      className="mr-0"
                    ></label>
                  </div>
                </th>
                <th width="7%" align="center" className="timecrd-tbl-innerth">
                  Date
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Day
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Cam Call
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Cam Wrap
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Travel To
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Start
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Meal
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Finish
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Travel From
                </th>
                <th width="4%" align="center" className="timecrd-tbl-innerth">
                  Hours
                </th>
                <th width="18%" align="center" className="timecrd-tbl-innerth">
                  Pmt Flags
                </th>
                <th width="18%" align="center" className="timecrd-tbl-innerth">
                  Employee Notes
                </th>
                <th width="18%" align="center" className="timecrd-tbl-innerth">
                  Internal Notes
                </th>
                <th width="7%" align="center" className="timecrd-tbl-innerth">
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody style={{ color: "#aaaaaa" }}>
              {weekEndingDate !== "" ? (
                dailyTimes.length === 0 ? (
                  <tr key="empty">
                    <td align="center" colSpan="5">
                      <strong>Please select period ending date.</strong>
                    </td>
                  </tr>
                ) : (
                  this.renderDailyTimesList(dailyTimes, view)
                )
              ) : (
                <tr key="empty">
                  <td align="center" colSpan="9">
                    <strong>Please select period ending date.</strong>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-sm-12 p0 ">
              <div className="flex__inner-wrapperone">
                <div className="label__total-wrapper label_timecard2">
                  Total(Hrs):
                </div>
                <div className=" ">
                  <button type="button" href="#" className="btn_price_time2">
                    <span>{weekEndingDate !== "" ? totalHours : "00:00"}</span>
                  </button>
                </div>

                <div className="ml-left-wrapper">
                  <button className="btn" onClick={this.zeroHours}>
                    Zero Hours
                  </button>
                </div>
                <div>
                  <button className="btn" onClick={this.clearPmtTages}>
                    Clear PMT Flags
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="departments__table2 table__advance--inner timcard-tbl-wrapperone">
            <h2>Advanced</h2>
            <table className="table " id="timecard-advanced-list" width="100%">
              <thead className="thead_bg hover-border">
                <tr>
                  <th
                    scope="col"
                    className="font--fourteen-wrapper calculate__tbl-thfirst"
                  >
                    {" "}
                  </th>
                  <th
                    scope="col"
                    className="font--fourteen-wrapper calculate__tbl-th"
                  >
                    <span className="user_setup_hed">Category</span>
                  </th>
                  <th
                    scope="col"
                    className="font--fourteen-wrapper calculate__tbl-desc"
                  >
                    <span className="user_setup_hed">Description</span>
                  </th>
                  <th
                    className="value__field--wrapperdept font--fourteen-wrapper calculate__tbl-th"
                    scope="col"
                  >
                    <span className="user_setup_hed">value</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {advancedList.map((list, i) => {
                  return (
                    <tr key={i}>
                      <td></td>
                      <td className=" ">{list.category}</td>
                      <td>{list.description}</td>
                      {list.valueType === "List" ? (
                        <td className="pt-0 pb-0 text-left">
                          <Select
                            classNamePrefix="custon_select-selector-inner main__dropdown--wrapper1"
                            styles={_customStyles}
                            isDisabled={list.readOnly === "Y" ? true : false}
                            value={{
                              label: list.value,
                              value: list.value,
                            }}
                            options={list.valueOptions}
                            onChange={(obj) =>
                              this.handleValueOptions("list", obj, list, i)
                            }
                            theme={(theme) => ({
                              ...theme,
                              border: 0,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                primary25: "#f2f2f2",
                                primary: "#f2f2f2",
                              },
                            })}
                          />
                        </td>
                      ) : list.valueType === "Date" ? (
                        <td>
                          <div className="table_input_field">
                            <RDatePicker
                              selected={this.formatDateWithoutTimeZone(Number(list.value))}
                              readOnly={list.readOnly === "Y" ? true : false}
                              dateFormat="d MMM yyyy"
                              autoComplete="off"
                              onChange={(date) =>
                                this.handleValueOptions("date", date, list, i)
                              }
                            />
                          </div>
                        </td>
                      ) : list.valueType === "Check" ? (
                        <td>
                          <div className="col-auto p-0">
                            <div className="form-group remember_check text-center pt-0 float-left">
                              <input
                                type="checkbox"
                                readOnly={list.readOnly === "Y" ? true : false}
                                id={`chk${i}`}
                                checked={
                                  list.value === "Y" || list.value === "1"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  this.handleValueOptions(
                                    "checkbox",
                                    e,
                                    list,
                                    i
                                  )
                                }
                              />
                              <label htmlFor={`chk${i}`}></label>
                            </div>
                          </div>
                        </td>
                      ) : list.valueType === "Numeric" ? (
                        <td>
                          <div className="table_input_field">
                            <input
                              type="number"
                              value={list.value}
                              readOnly={list.readOnly === "Y" ? true : false}
                              onChange={(e) =>
                                this.handleValueOptions("number", e, list, i)
                              }
                            />
                          </div>
                        </td>
                      ) : list.valueType === "Text" ? (
                        <td>
                          <div className="table_input_field">
                            <input
                              type="text"
                              value={list.value}
                              readOnly={list.readOnly === "Y" ? true : false}
                              onChange={(e) =>
                                this.handleValueOptions("text", e, list, i)
                              }
                            />
                          </div>
                        </td>
                      ) : (
                        <td>{list.value}</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="col-12 mt-2 p-0">
            <div className="form-group custon_select border text-center mb-0 border-rad-5 image__upload--wrapper mb-3">
              <div id="drop-area">
                <input
                  type="file"
                  id="fileElem"
                  className="form-control d-none"
                  accept="application/pdf"
                  onChange={(e) => {
                    this.uploadAttachment(e.target.files);
                  }}
                  onClick={(event) => {
                    event.currentTarget.value = null;
                  }} //to upload the same file again
                />
                <label className="upload-label" htmlFor="fileElem">
                  <div className="upload-text">
                    <img
                      src="images/drag-file.png"
                      className="import_icon img-fluid"
                      alt="upload-attachment"
                    />
                  </div>
                </label>
              </div>
            </div>
          </div>
          {attachments.length > 0 &&
            attachments.map((a, i) => {
              return (
                <div key={i} className="col-md-12 mb-md-4">
                  <span className="del_notes">
                    <i
                      onClick={() => this.deleteAttachment(a.recordID)}
                      className="fa fa-times cursorPointer"
                    ></i>

                    <span
                      onClick={() => this.state.newTc ? null : this.getAttachment(a.recordID)}
                      className="cursorPointer"
                    >
                      {a.fileName || ""}
                    </span>
                  </span>
                </div>
              );
            })}
          <div className="mtop-wrapper">
            <button
              className="btn btn__save-wrapper"
              onClick={() => {
                this.updateTimecard();
              }}
            >
              Save
            </button>
            <button className="btn btn__cancel-wrapper" onClick={this.onCancel}>
              Cancel
            </button>
          </div>
        </div>
      );
    }
  };

  // hanldle change field
  handleChangeField = async (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };

  closeModal = (name) => {
    this.setState({ [name]: false });
  };

  handleChangeDayTimeType = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };

  updateTimeType = async (e, modal) => {
    let { name, value } = e.target;
    let { format } = this.state;
    value = value ? value.trim() : "";
    let isValid = true;
    if (value.length > 5) {
      isValid = false;
    } else {
      let timeParts = value.split(/[:,.]/);
      if (timeParts.length > 2) {
        isValid = false;
      } else if (timeParts.length === 1) {
        value = ("0000" + value).slice(-4);
        value = value.substring(0, 2) + ":" + value.substring(2, value.length);
      } else {
        value =
          ("00" + timeParts[0]).slice(-2) +
          ":" +
          ("00" + timeParts[1]).slice(-2);
      }
    }

    if (!moment(value, this.state.format, true).isValid() || !isValid) {
      value = "00:00";
      toast.error("Time string is not valid.");
    }

    this.setState(
      {
        [name]: value,
      },
      () => {
        if (name === "camCallType") {
          this.handleChangeCamCallTime(moment(value, format), value);
        } else if (name === "camWrapType") {
          this.handleChangeCamWrapTime(moment(value, format), value);
        } else if (name === "travelToType") {
          this.handleChangeDayFromTravel(
            moment(value, format),
            value,
            "",
            modal
          );
        } else if (name === "startWorkType") {
          this.handleChangeDayTimeStart(moment(value, format), value);
        } else if (name === "finishWorkType") {
          this.handleChangeDayTimeFinish(moment(value, format), value);
        } else if (name === "travelFromType") {
          this.handleChangeDayToTravel(
            moment(value, format),
            value,
            "",
            modal
          );
        } else if (name === "totalMBType") {
          this.handleChangeDayTimeTotalMBDed(moment(value, format), value);
        } else if (name === "startMB1Type") {
          this.handleChangeDayTimeStartMeal(moment(value, format), value);
        } else if (name === "finishMB1Type") {
          this.handleChangeDayTimeFinishMeal1(moment(value, format), value);
        } else if (name === "startMB2Type") {
          this.handleChangeDayTimeStartMeal2(moment(value, format), value);
        } else if (name === "finishMB2Type") {
          this.handleChangeDayTimeFinishMeal2(moment(value, format), value);
        } else if (name === "startMB3Type") {
          this.handleChangeDayTimeStartMeal3(moment(value, format), value);
        } else if (name === "finishMB3Type") {
          this.handleChangeDayTimeFinishMeal3(moment(value, format), value);
        } else {
        }
      }
    );
  };

  handleChangeDayTimeTypeInline = async (event, index) => {
    let value = event.target.value;
    let name = event.target.name;
    let day = this.state.dailyTimes[index];
    let dailyTimes = this.state.dailyTimes;

    var dayTimeObj = {
      ...dailyTimes[index],
      camCall: name === "camCall" ? value : day.camCall,
      camWrap: name === "camWrap" ? value : day.camWrap,
      travelTo: name === "travelTo" ? value : day.travelTo,
      travelFrom: name === "travelFrom" ? value : day.travelFrom,
      startWork: name === "startWork" ? value : day.startWork,
      totalMB: name === "totalMB" ? value : day.totalMB,
      finishWork: name === "finishWork" ? value : day.finishWork,
    };
    dailyTimes[index] = dayTimeObj;

    this.setState({ dailyTimes });
  };

  updateTimeTypeInline = async (e, index, modal) => {
    let { format } = this.state;
    let name = e.target.name;
    var value = e.target.value;
    value = value ? value.trim() : "";
    var isValid = true;
    if (value.length > 5) {
      isValid = false;
    } else {
      let timeParts = value.split(/[:,.]/);

      if (timeParts.length > 2) {
        isValid = false;
      } else if (timeParts.length === 1) {
        value = ("0000" + value).slice(-4);
        value = value.substring(0, 2) + ":" + value.substring(2, value.length);
      } else {
        value =
          ("00" + timeParts[0]).slice(-2) +
          ":" +
          ("00" + timeParts[1]).slice(-2);
        //value = value.substring(0, 2) + ":" + value.substring(2, value.length);
      }
    }

    if (!moment(value, this.state.format, true).isValid() || !isValid) {
      value = "00:00";
      toast.error("Time string is not valid.");
    }

    if (name === "camCall") {
      this.handleChangeCamCallTime(moment(value, format), value, index);
    } else if (name === "camWrap") {
      this.handleChangeCamWrapTime(moment(value, format), value, index);
    } else if (name === "travelTo") {
      this.handleChangeDayToTravel(
        moment(value, format),
        value,
        index,
        modal
      );      
    } else if (name === "startWork") {
      this.handleChangeDayTimeStartInline(moment(value, format), value, index);
    } else if (name === "finishWork") {
      this.handleChangeDayTimeFinishInline(moment(value, format), value, index);
    } else if (name === "travelFrom") {
      this.handleChangeDayFromTravel(
        moment(value, format),
        value,
        index,
        modal
      );
    } else if (name === "totalMB") {
      this.handleChangeDayTimeTotalMBDedInline(moment(value, format), value, index);
    } else {
    }
  };

  render() {
    let {
      width,
      isLoading,
      subView,
      dayTimeDateMoment,
      dailyTimes,
      dateFormat,
      minuteStep,
      inputReadOnly,
      allowEmpty,
      startWork,
      format,
      payAs,
      day,
      travelFrom,
      totalMB,
      totalMBDedDisabled,
      startMB1,
      finishMB1,
      startMB2,
      finishMB2,
      startMB3,
      finishMB3,
      nonDeductableMB2,
      nonDeductableMB1,
      nonDeductableMB3,
      finishWork,
      travelTo,
      totalHours,
      notes,
      internalNotes,
      dayTimeIndex,
      saveDayTimeError,
      openCalculateDayModal,
      openEmployeeLookupModal,
      employeeList,
      employeeName,
      employeeCode,
      dayTimeCopyIndex,
      dayTimeTotalHours,
      dailyTimeAdvancedList,
      showHiddenRowsDailyTime,
    } = this.state;
    return (
      <>
        {isLoading ? <div className="se-pre-con"></div> : ""}

        {width >= 768 ? (
          <>
            {" "}
            <Header props={this.props} timecards={true} />
            <TopNav />
          </>
        ) : (
          ""
        )}

        <div
          className="col-xs-12  col-sm-12 col-md-12 mrg_dashboard_right timecard--inner--container"
          style={{ background: "#ffffff", color: "#707070" }}
        >
          {isLoading ? <div className="is-loading"></div> : ""}
          <div className="clear40"></div>

          {width >= 768 ? (
            subView === "Add" ? (
              this.renderAddView("web")
            ) : (
              ""
            )
          ) : (
            <>
              {subView === "Add" ? this.renderAddView("mobile") : ""}

              {subView === "WeekTimes" ? this.renderWeekTimes("mobile") : ""}
              {subView === "DayTimes" ? this.renderDayTimes("mobile") : ""}
              {subView === "BreakTimes" ? this.renderBreakTimes("mobile") : ""}
            </>
          )}

          {/*WeekTimesModalCenter Start*/}
          <div
            className="modal fade custm__mdl-wrapper timecard-mdl"
            id="WeekTimesModalCenter"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered timecard_2popup"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header modal_header_register">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="WeekTimesModalCenterClose"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body register_suc timecard2_popup register_suc_scrol">
                  <button
                    type="button"
                    className="btn_copytime"
                    onClick={() =>
                      this.handleCopyYesterdaysTimes(dayTimeCopyIndex)
                    }
                  >
                    <span>Copy Yesterdays Times </span>
                  </button>

                  <div className="clear20"></div>

                  <div className="col-sm-12 profile_setting_pop">
                    <form className="form-horizontal" action="/action_page.php">
                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Pay As"
                        >
                          Pay As
                        </label>
                        <div className="col-sm-5">
                          <select
                            className="form-control pro_input_pop"
                            name="payAs"
                            value={payAs}
                            onChange={this.handleChangeDayTime}
                          >
                            <option value="0">Select</option>
                            {this.renderPayasDropdown()}
                          </select>
                        </div>
                      </div>
                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Last Name"
                        >
                          Date
                        </label>
                        <div
                          className="col-sm-6 period_ending_popup3"
                          style={{ textAlign: "left" }}
                        >
                          <RDatePicker
                            selected={moment(
                              this.dailyTimesDateFormat(this.state.date),
                              dateFormat
                            )?.toDate() || new Date()}
                            onChange={(e) => {
                              const momentInstance = moment(e);
                              this.handlerDateChangeForIndividualLine(momentInstance);
                            }}
                            dateFormat={dateFormat?.replace(/D/g, 'd')?.replace(/Y/g, 'y')}
                            className="clndr-select"
                          ></RDatePicker>
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Email"
                        >
                          Day
                        </label>
                        <div
                          className="col-sm-8 text-left"
                          style={{ paddingTop: "7px" }}
                        >
                          {this.state.day}
                        </div>
                      </div>
                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Cam Call
                        </label>
                        <div className="col-sm-8" style={{ textAlign: "left" }}>
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              // minuteStep={minuteStep}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={moment(this.state.camCall, format)}
                              format={format}
                              onChange={(moment, time) =>
                                this.handleChangeCamCallTime(moment, time)
                              }
                              id={`camCall_edit`}
                              onClick={() => this.fixOverflowIssue(`camCall_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="camCallType"
                              value={
                                this.state.camCallType == "00:00"
                                  ? ""
                                  : this.state.camCallType
                              }
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>
                      </div>
                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Cam Wrap
                        </label>
                        <div className="col-sm-8" style={{ textAlign: "left" }}>
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              // minuteStep={minuteStep}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={moment(this.state.camWrap, format)}
                              format={format}
                              onChange={(moment, time) =>
                                this.handleChangeCamWrapTime(moment, time)
                              }
                              id={`camWrap_edit`}
                              onClick={() => this.fixOverflowIssue(`camWrap_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="camWrapType"
                              value={
                                this.state.camWrapType == "00:00"
                                  ? ""
                                  : this.state.camWrapType
                              }
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Travel To
                        </label>
                        <div className="col-sm-8" style={{ textAlign: "left" }}>
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              // minuteStep={minuteStep}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={moment(this.state.travelTo, format)}
                              format={format}
                              onChange={(m, t) =>
                                this.handleChangeDayToTravel(m, t, "", true)
                              }
                              id={`travelTo_edit`}
                              onClick={() => this.fixOverflowIssue(`travelTo_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="travelToType"
                              value={
                                this.state.travelToType == "00:00"
                                  ? ""
                                  : this.state.travelToType
                              }
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Start Work
                        </label>
                        <div className="col-sm-8" style={{ textAlign: "left" }}>
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              // minuteStep={minuteStep}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={startWork}
                              format={format}
                              onChange={this.handleChangeDayTimeStart}
                              id={`startWork_edit`}
                              onClick={() => this.fixOverflowIssue(`startWork_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="startWorkType"
                              value={
                                this.state.startWorkType == "00:00"
                                  ? ""
                                  : this.state.startWorkType
                              }
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Meal Break
                        </label>
                        <div className="col-sm-3">
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              // minuteStep={minuteStep}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={totalMB}
                              format={format}
                              onChange={this.handleChangeDayTimeTotalMBDed}
                              disabled={totalMBDedDisabled}
                              id={`mealBreak_edit`}
                              onClick={() => this.fixOverflowIssue(`mealBreak_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="totalMBType"
                              value={
                                this.state.totalMBDedDisabled
                                  ? moment(totalMB, "hmm").format("HH:mm")
                                  : this.state.totalMBType == "00:00"
                                  ? ""
                                  : this.state.totalMBType
                              }
                              disabled={this.state.totalMBDedDisabled}
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>

                        <div className="col-sm-2 p0">
                          <div id="accordion">
                            <div className="card">
                              <div
                                className="card-header card__header--wrapper1"
                                id="headingfour"
                              >
                                {/* <h5 className="mb-0"> */}
                                <p
                                  className="btn btn-link btn__chevron--wrapper"
                                  data-toggle="collapse"
                                  data-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >
                                  <i
                                    className="fa fa-chevron-down rotate"
                                    aria-hidden="true"
                                  ></i>
                                </p>
                                {/* </h5> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse "
                        aria-labelledby="headingfour"
                        data-parent="#accordion"
                      >
                        <div className="card-body crd__custm--wrapper">
                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Start MB1
                            </label>
                            <div
                              className="col-sm-8"
                              style={{ textAlign: "left" }}
                            >
                              {this.state.timecardEntry !== "Text" ? (
                                <TimePicker
                                  showNow={false}
                                  allowClear={false}
                                  // minuteStep={minuteStep}
                                  minuteStep={
                                    this.state.timecardInterval
                                      ? this.state.timecardInterval
                                      : 1
                                  }
                                  inputReadOnly={inputReadOnly}
                                  allowEmpty={allowEmpty}
                                  value={startMB1}
                                  format={format}
                                  onChange={this.handleChangeDayTimeStartMeal}
                                  id={`startMB1_edit`}
                                  onClick={() => this.fixOverflowIssue(`startMB1_edit`)}
                                  getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control pro_input_pop custom-time-field"
                                  name="startMB1Type"
                                  value={
                                    this.state.startMB1Type == "00:00"
                                      ? ""
                                      : this.state.startMB1Type
                                  }
                                  placeholder="00:00"
                                  onChange={this.handleChangeDayTimeType}
                                  onBlur={(e) => this.updateTimeType(e, true)}
                                />
                              )}
                            </div>
                          </div>

                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Finish MB1
                            </label>
                            <div
                              className="col-sm-8"
                              style={{ textAlign: "left" }}
                            >
                              {this.state.timecardEntry !== "Text" ? (
                                <TimePicker
                                  showNow={false}
                                  allowClear={false}
                                  // minuteStep={minuteStep}
                                  minuteStep={
                                    this.state.timecardInterval
                                      ? this.state.timecardInterval
                                      : 1
                                  }
                                  inputReadOnly={inputReadOnly}
                                  allowEmpty={allowEmpty}
                                  value={finishMB1}
                                  format={format}
                                  onChange={this.handleChangeDayTimeFinishMeal1}
                                  id={`finishMB1_edit`}
                                  onClick={() => this.fixOverflowIssue(`finishMB1_edit`)}
                                  getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control pro_input_pop custom-time-field"
                                  name="finishMB1Type"
                                  value={
                                    this.state.finishMB1Type == "00:00"
                                      ? ""
                                      : this.state.finishMB1Type
                                  }
                                  placeholder="00:00"
                                  onChange={this.handleChangeDayTimeType}
                                  onBlur={(e) => this.updateTimeType(e, true)}
                                />
                              )}
                            </div>
                          </div>

                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Start MB2
                            </label>
                            <div
                              className="col-sm-8"
                              style={{ textAlign: "left" }}
                            >
                              {this.state.timecardEntry !== "Text" ? (
                                <TimePicker
                                  showNow={false}
                                  allowClear={false}
                                  // minuteStep={minuteStep}
                                  minuteStep={
                                    this.state.timecardInterval
                                      ? this.state.timecardInterval
                                      : 1
                                  }
                                  inputReadOnly={inputReadOnly}
                                  allowEmpty={allowEmpty}
                                  value={startMB2}
                                  format={format}
                                  onChange={this.handleChangeDayTimeStartMeal2}
                                  id={`startMB2_edit`}
                                  onClick={() => this.fixOverflowIssue(`startMB2_edit`)}
                                  getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control pro_input_pop custom-time-field"
                                  name="startMB2Type"
                                  value={
                                    this.state.startMB2Type == "00:00"
                                      ? ""
                                      : this.state.startMB2Type
                                  }
                                  placeholder="00:00"
                                  onChange={this.handleChangeDayTimeType}
                                  onBlur={(e) => this.updateTimeType(e, true)}
                                />
                              )}
                            </div>
                          </div>

                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Finish MB2
                            </label>
                            <div
                              className="col-sm-8"
                              style={{ textAlign: "left" }}
                            >
                              {this.state.timecardEntry !== "Text" ? (
                                <TimePicker
                                  showNow={false}
                                  allowClear={false}
                                  minuteStep={
                                    this.state.timecardInterval
                                      ? this.state.timecardInterval
                                      : 1
                                  }
                                  inputReadOnly={inputReadOnly}
                                  allowEmpty={allowEmpty}
                                  value={finishMB2}
                                  format={format}
                                  onChange={this.handleChangeDayTimeFinishMeal2}
                                  id={`finishMB2_edit`}
                                  onClick={() => this.fixOverflowIssue(`finishMB2_edit`)}
                                  getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control pro_input_pop custom-time-field"
                                  name="finishMB2Type"
                                  value={
                                    this.state.finishMB2Type == "00:00"
                                      ? ""
                                      : this.state.finishMB2Type
                                  }
                                  placeholder="00:00"
                                  onChange={this.handleChangeDayTimeType}
                                  onBlur={(e) => this.updateTimeType(e, true)}
                                />
                              )}
                            </div>
                          </div>
                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Start MB3
                            </label>
                            <div
                              className="col-sm-8"
                              style={{ textAlign: "left" }}
                            >
                              {this.state.timecardEntry !== "Text" ? (
                                <TimePicker
                                  showNow={false}
                                  allowClear={false}
                                  minuteStep={
                                    this.state.timecardInterval
                                      ? this.state.timecardInterval
                                      : 1
                                  }
                                  inputReadOnly={inputReadOnly}
                                  allowEmpty={allowEmpty}
                                  value={startMB3}
                                  format={format}
                                  onChange={this.handleChangeDayTimeStartMeal3}
                                  id={`startMB3_edit`}
                                  onClick={() => this.fixOverflowIssue(`startMB3_edit`)}
                                  getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control pro_input_pop custom-time-field"
                                  name="startMB3Type"
                                  value={
                                    this.state.startMB3Type == "00:00"
                                      ? ""
                                      : this.state.startMB3Type
                                  }
                                  placeholder="00:00"
                                  onChange={this.handleChangeDayTimeType}
                                  onBlur={(e) => this.updateTimeType(e, true)}
                                />
                              )}
                            </div>
                          </div>
                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Finish MB3
                            </label>
                            <div
                              className="col-sm-8"
                              style={{ textAlign: "left" }}
                            >
                              {this.state.timecardEntry !== "Text" ? (
                                <TimePicker
                                  showNow={false}
                                  allowClear={false}
                                  minuteStep={
                                    this.state.timecardInterval
                                      ? this.state.timecardInterval
                                      : 1
                                  }
                                  inputReadOnly={inputReadOnly}
                                  allowEmpty={allowEmpty}
                                  value={finishMB3}
                                  format={format}
                                  onChange={this.handleChangeDayTimeFinishMeal3}
                                  id={`finishMB3_edit`}
                                  onClick={() => this.fixOverflowIssue(`finishMB3_edit`)}
                                  getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control pro_input_pop custom-time-field"
                                  name="finishMB3Type"
                                  value={
                                    this.state.finishMB3Type == "00:00"
                                      ? ""
                                      : this.state.finishMB3Type
                                  }
                                  placeholder="00:00"
                                  onChange={this.handleChangeDayTimeType}
                                  onBlur={(e) => this.updateTimeType(e, true)}
                                />
                              )}
                            </div>
                          </div>

                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Non Deductible MB1:
                            </label>
                            <div className="col-sm-1 checkbox_popuptime">
                              <input
                                type="checkbox"
                                name="nonDeductableMB1"
                                onChange={this.handleChangeDayTime}
                                checked={nonDeductableMB1}
                              />
                            </div>
                          </div>

                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Non Deductible MB2:
                            </label>
                            <div className="col-sm-1 checkbox_popuptime">
                              <input
                                type="checkbox"
                                name="nonDeductableMB2"
                                onChange={this.handleChangeDayTime}
                                checked={nonDeductableMB2}
                              />
                            </div>
                          </div>

                          <div className="form-group form__inner-flex">
                            <label
                              className="control-label col-sm-3 form__lbl--one"
                              htmlFor="Mobile"
                            >
                              Non Deductible MB3:
                            </label>
                            <div className="col-sm-1 checkbox_popuptime">
                              <input
                                type="checkbox"
                                name="nonDeductableMB3"
                                onChange={this.handleChangeDayTime}
                                checked={nonDeductableMB3}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Finish Work
                        </label>
                        <div className="col-sm-8" style={{ textAlign: "left" }}>
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              // minuteStep={minuteStep}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={finishWork}
                              format={format}
                              onChange={this.handleChangeDayTimeFinish}
                              id={`finishWork_edit`}
                              onClick={() => this.fixOverflowIssue(`finishWork_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="finishWorkType"
                              value={
                                this.state.finishWorkType == "00:00"
                                  ? ""
                                  : this.state.finishWorkType
                              }
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>
                      </div>
                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Travel From
                        </label>
                        <div className="col-sm-8" style={{ textAlign: "left" }}>
                          {this.state.timecardEntry !== "Text" ? (
                            <TimePicker
                              showNow={false}
                              allowClear={false}
                              minuteStep={
                                this.state.timecardInterval
                                  ? this.state.timecardInterval
                                  : 1
                              }
                              inputReadOnly={inputReadOnly}
                              allowEmpty={allowEmpty}
                              value={moment(this.state.travelFrom, format)}
                              format={format}
                              onChange={(m, t) =>
                                this.handleChangeDayFromTravel(m, t, "", true)
                              }
                              id={`travelFrom_edit`}
                              onClick={() => this.fixOverflowIssue(`travelFrom_edit`)}
                              getPopupContainer={(triggerNode) => (triggerNode.childNodes[0])}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control pro_input_pop custom-time-field"
                              name="travelFromType"
                              value={
                                this.state.travelFromType == "00:00"
                                  ? ""
                                  : this.state.travelFromType
                              }
                              placeholder="00:00"
                              onChange={this.handleChangeDayTimeType}
                              onBlur={(e) => this.updateTimeType(e, true)}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Total Hours
                        </label>
                        <div
                          className="col-sm-8 text-left"
                          style={{ paddingLeft: "27px", paddingTop: "7px" }}
                        >
                          {dayTimeTotalHours}
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Employee Notes
                        </label>
                        <div className="col-sm-8">
                          <textarea
                            name="notes"
                            value={notes ? notes : ""}
                            className="form-control pro_input_pop"
                            rows=""
                            onChange={(e) => this.inputHandlerChangeFeild(e)}
                            // onChange={this.handleChangeDayTime}
                          ></textarea>
                        </div>
                      </div>

                      <div className="form-group form__inner-flex">
                        <label
                          className="control-label col-sm-3 form__lbl--one"
                          htmlFor="Mobile"
                        >
                          Internal Notes
                        </label>
                        <div className="col-sm-8">
                          <textarea
                            name="internalNotes"
                            value={internalNotes ? internalNotes : ""}
                            className="form-control pro_input_pop"
                            rows=""
                            onChange={(e) => this.inputHandlerChangeFeild(e)}
                            // onChange={this.handleChangeDayTime}
                          ></textarea>
                        </div>
                      </div>

                      <div className="departments__table2">
                        <h2>Advanced</h2>
                        <table
                          className="table mb-3"
                          id="dailyTimes-table"
                          width="100%"
                        >
                          <thead className="thead_bg hover-border">
                            <tr>
                              <th scope="col"> </th>
                              <th scope="col">
                                <span className="user_setup_hed">Category</span>
                              </th>
                              <th scope="col">
                                <span className="user_setup_hed">
                                  Description
                                </span>
                              </th>
                              <th
                                className="value__field--wrapperdept"
                                scope="col"
                              >
                                <span className="user_setup_hed">value</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {dailyTimeAdvancedList.map((list, i) => {
                              return (
                                <tr key={i}>
                                  <td></td>
                                  <td className=" ">{list.category}</td>
                                  <td>{list.description}</td>
                                  {list.valueType === "List" ? (
                                    <td className="pt-0 pb-0 text-left">
                                      <Select
                                        classNamePrefix="custon_select-selector-inner main__dropdown--wrapper1"
                                        styles={_customStyles}
                                        value={{
                                          label: list.value,
                                          value: list.value,
                                        }}
                                        options={list.valueOptions}
                                        onChange={(obj) =>
                                          this.handleValueOptionsDailyTimes(
                                            "list",
                                            obj,
                                            list,
                                            i
                                          )
                                        }
                                        theme={(theme) => ({
                                          ...theme,
                                          border: 0,
                                          borderRadius: 0,
                                          colors: {
                                            ...theme.colors,
                                            primary25: "#f2f2f2",
                                            primary: "#f2f2f2",
                                          },
                                        })}
                                      />
                                    </td>
                                  ) : list.valueType === "Date" ? (
                                    <td>
                                      <div className="table_input_field">
                                        <RDatePicker
                                          selected={this.formatDateWithoutTimeZone(Number(list.value))}
                                          dateFormat="d MMM yyyy"
                                          autoComplete="off"
                                          getPopupContainer={(triggerNode) =>
                                            triggerNode.parentNode
                                          }
                                          onChange={(date) =>
                                            this.handleValueOptionsDailyTimes(
                                              "date",
                                              date,
                                              list,
                                              i
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  ) : list.valueType === "Check" ? (
                                    <td>
                                      <div className="col-auto p-0">
                                        <div className="form-group remember_check text-center pt-0 float-left">
                                          <input
                                            type="checkbox"
                                            id={`chk${i}`}
                                            checked={
                                              list.value === "Y" ||
                                              list.value === "1"
                                                ? true
                                                : false
                                            }
                                            onChange={(e) =>
                                              this.handleValueOptionsDailyTimes(
                                                "checkbox",
                                                e,
                                                list,
                                                i
                                              )
                                            }
                                          />
                                          <label htmlFor={`chk${i}`}></label>
                                        </div>
                                      </div>
                                    </td>
                                  ) : list.valueType === "Numeric" ? (
                                    <td>
                                      <div className="table_input_field">
                                        <input
                                          type="number"
                                          value={list.value}
                                          onChange={(e) =>
                                            this.handleValueOptionsDailyTimes(
                                              "number",
                                              e,
                                              list,
                                              i
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  ) : list.valueType === "Text" ? (
                                    <td>
                                      <div className="table_input_field">
                                        <input
                                          type="text"
                                          value={list.value}
                                          onChange={(e) =>
                                            this.handleValueOptionsDailyTimes(
                                              "text",
                                              e,
                                              list,
                                              i
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  ) : (
                                    <td>{list.value}</td>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div className="clear20"></div>
                      <div className="btn_cance_save">
                        <input
                          name=""
                          className="btn_save_pro"
                          value="Save"
                          type="button"
                          onClick={() =>
                            this.handleSaveDayTime(dayTimeIndex, "Add", true)
                          }
                        />
                        <input
                          name=""
                          className="btn_cancel_pro"
                          data-dismiss="modal"
                          aria-label="Close"
                          value="Cancel"
                          type="button"
                        />
                      </div>
                    </form>

                    <div className="btn_cance_save2">
                      <input
                        name=""
                        type="button"
                        className="btn_save_pro"
                        value="Save"
                      />
                      <input
                        name=""
                        type="button"
                        className="btn_cancel_pro"
                        value="Cancel"
                      />
                    </div>
                  </div>
                  <div className="clear10"></div>
                  <span
                    className="doc_file_error"
                    style={{ position: "initial" }}
                  >
                    {saveDayTimeError ? saveDayTimeError : ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/*WeekTimesModalCenter END*/}
          <button
            data-dismiss="modal"
            data-toggle="modal"
            data-target="#WeekTimesModalCenter"
            id="WeekTimesModalCenterBtn"
            style={{ display: "none" }}
          >
            Show Modal
          </button>
        </div>
        <Prompt when={this.state.openUnsavedChangesModal} message="You are leaving the page without saving your changes. All unsaved changes will be lost!" />

        {/* {openCalculateDayModal && ( */}
        <CalculateDayModal
          tran={this.state.tran}
          dailyTimes={this.state.dailyTimes}
          calculateDayTimeCard={this.state.dayCalculateData}
          openCalculateDayModal={openCalculateDayModal}
          closeModal={this.closeCalculateModal}
        />
        {/* )} */}
        <EmployeeLookup
          openEmployeeLookupModal={openEmployeeLookupModal}
          employeeList={employeeList}
          employeeName={employeeName}
          employeeCode={employeeCode}
          updateParentState={this.updateParentState}
          closeModal={() => this.setState({ openEmployeeLookupModal: false })}
          refreshEmployees={this.refreshEmployees}
          getEmployeeDetailsList={this.getEmployeeDetailsList}
        />
        <DeleteTimecards
          openDeleteModal={this.state.openDeleteModal}
          closeModal={this.closeModal}
          onDelete={this.deleteTimecard}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  timecard: state.timecard,
  user: state.user,
});

export default withRouter(connect(
  mapStateToProps,{
    primeTimecard: TimecardActions.primeTimecard,
    copyLastWeeksTimes: TimecardActions.copyLastWeeksTimes,
    insertTimecard: TimecardActions.insertTimecard,
    updateTimecard: TimecardActions.updateTimecard,
    getTimecard: TimecardActions.getTimecard,
    getEmployeeList: TimecardActions.getEmployeeList,
    refreshEmployees: TimecardActions.refreshEmployees,
    addAttachment: TimecardActions.addAttachment,
    deleteAttachment: TimecardActions.deleteAttachment,
    getAttachment: TimecardActions.getAttachment,
    clearTimecardStates: TimecardActions.clearTimecardStates,
    setUserSettings: UserActions.setUserSettings,
    getEmployeeDetailsList: TimecardActions.getEmployeeDetailsList,
    getTimecardSummary: TimecardActions.getTimecardSummary,
    deleteTimecard: TimecardActions.deleteTimecard,
  }
  )(TimeCard));